// Translations for SUCO - 9 languages
const translations = {
  es: {
    // Landing
    landing_subtitle: "Tu voz importa.",
    landing_description: "Comparte tus experiencias y mejora el servicio.",
    btn_get_started: "Empezar",
    btn_have_account: "Ya tengo cuenta",
    
    // Register
    register_title: "Registra tu negocio",
    register_subtitle: "Crea tu cuenta y obtén tu QR personalizado",
    business_name: "Nombre del negocio",
    email: "Correo electrónico",
    phone: "Teléfono (opcional)",
    password: "Contraseña",
    poster_language: "Idioma del cartel",
    your_logo: "Tu logo (opcional)",
    upload_file: "Subir archivo",
    logo_url: "URL del logo",
    logo_hint: "JPG, PNG o WEBP (máx 5MB). Deja vacío para usar el logo de SUCO",
    btn_start_trial: "Iniciar prueba gratis de 7 días",
    registering: "Registrando...",
    register_success: "¡Negocio registrado! Tienes 7 días de prueba gratis",
    
    // Login
    login_title: "Iniciar sesión",
    btn_login: "Ingresar",
    logging_in: "Ingresando...",
    no_account: "¿No tienes cuenta?",
    sign_up: "Regístrate",
    welcome_back: "¡Bienvenido de vuelta!",
    
    // Dashboard
    dashboard_subtitle: "Panel de administración",
    tab_overview: "Resumen",
    tab_complaints: "Quejas & Sugerencias",
    tab_qr: "Mi QR",
    btn_logout: "Salir",
    free_trial: "Prueba gratis",
    
    // Stats
    stat_total: "Total",
    stat_pending: "Pendientes",
    stat_resolved: "Resueltos",
    stat_complaints: "Quejas",
    stat_suggestions: "Sugerencias",
    
    // Complaints
    no_messages: "Sin mensajes aún",
    share_qr: "Comparte tu QR para recibir feedback",
    complaint: "Queja",
    suggestion: "Sugerencia",
    change_status: "Cambiar estado",
    status_pending: "Pendiente",
    status_in_progress: "En proceso",
    status_resolved: "Resuelto",
    status_closed: "Cerrado",
    
    // QR Tab
    qr_title: "Tu código QR personalizado",
    qr_subtitle: "Compártelo con tus clientes para recibir feedback",
    public_url: "URL pública:",
    download_qr: "Descargar QR",
    download_pdf: "Descargar PDF",
    download_docx: "Descargar DOCX",
    wifi_qr_title: "QR de WiFi",
    wifi_qr_subtitle: "Genera un QR para que tus clientes se conecten a tu red WiFi",
    wifi_network_name: "Nombre de la red",
    wifi_password: "Contraseña",
    wifi_password_placeholder: "Dejar vacío si no tiene contraseña",
    wifi_security: "Tipo de seguridad",
    wifi_no_password: "Sin contraseña",
    wifi_generate_btn: "Generar QR de WiFi",
    wifi_qr_generated: "QR de WiFi generado correctamente",
    wifi_ssid_required: "El nombre de la red es obligatorio",
    wifi_download_qr: "Descargar QR de WiFi",
    tab_branches: "Sucursales",
    branches_title: "WiFi por Sucursal",
    branches_subtitle: "Genera un QR de WiFi independiente para cada una de tus sucursales",
    branches_no_branches: "Aún no tienes sucursales registradas. Agrégalas desde tu cuenta empresarial.",
    branch_label: "Sucursal",
    branch_wifi_for: "WiFi de la sucursal",
    regenerate_qr: "Regenerar QR",
    qr_regenerated: "QR y carteles regenerados correctamente",
    
    // Feedback Form
    feedback_question: "¿Cuál es tu queja o sugerencia?",
    category: "Categoría",
    describe_problem: "Describe el problema o tu sugerencia",
    tell_us: "Cuéntanos tu experiencia...",
    name_optional: "Nombre (opcional)",
    email_optional: "Correo electrónico (opcional)",
    phone_optional: "Teléfono (opcional)",
    btn_send: "Enviar",
    btn_clear: "Limpiar",
    sending: "Enviando...",
    thank_you: "¡Gracias!",
    message_sent: "Tu mensaje ha sido enviado correctamente.",
    send_another: "Enviar otro",
    powered_by: "Powered by SUCO",
    
    // Subscription
    choose_plan: "Elige tu plan",
    plan_subtitle: "Disfruta 7 días gratis, luego elige el plan que mejor se adapte a ti",
    monthly: "Plan Mensual",
    yearly: "Plan Anual",
    savings: "de ahorro",
    btn_subscribe: "Suscribirse",
    processing: "Procesando...",
    per_year: "/año",
    per_month: "/mes",
    loading_plans: "Cargando planes...",
    verifying_payment: "Verificando pago...",
    wait_confirmation: "Por favor espera mientras confirmamos tu pago",
    payment_success: "¡Pago exitoso!",
    subscription_active: "Tu suscripción está activa",
    trial_banner: "Prueba gratis: te quedan {days} días",
    trial_banner_last_day: "Prueba gratis: último día",
    trial_expired: "Tu prueba gratis ha expirado",
    trial_expired_msg: "Suscríbete para seguir usando SUCO",
    cancel_subscription: "Cancelar suscripción",
    cancel_confirm: "¿Estás seguro? Perderás acceso al finalizar tu periodo de pago",
    subscription_cancelled: "Suscripción cancelada correctamente",
    go_dashboard: "Ir al Dashboard",
    payment_error: "Error en el pago",
    payment_confirm_error: "No pudimos confirmar tu pago",
    try_again: "Intentar de nuevo",
    your_name: "Tu nombre",
    email_placeholder: "correo@ejemplo.com",
    phone_placeholder: "+52 555 123 4567",
    error_payment: "Error al iniciar pago",
    
    // Errors
    business_not_found: "Negocio no encontrado",
    back_home: "Volver al inicio",
    loading: "Cargando...",
    error_loading: "Error al cargar datos",
    invalid_credentials: "Credenciales inválidas",
    error_registering: "Error al registrar",
    error_sending: "Error al enviar",
    status_updated: "Estado actualizado",
    
    // Profile
    tab_profile: "Mi Perfil",
    profile_title: "Editar Perfil",
    profile_subtitle: "Actualiza la información de tu negocio",
    email_cc: "Email CC (notificaciones)",
    email_cc_hint: "Este email también recibirá las notificaciones de quejas y sugerencias",
    change_logo: "Cambiar logo",
    save_changes: "Guardar cambios",
    support: "Soporte",
    download_email_template: "Descargar correo comercial (Word)",
    saving: "Guardando...",
    profile_updated: "Perfil actualizado correctamente",
    error_updating: "Error al actualizar el perfil",
    current_logo: "Logo actual",
    no_logo: "Sin logo personalizado",
    
    // Analytics
    tab_analytics: "Analytics",
    analytics_title: "Análisis de Tendencias",
    analytics_subtitle: "Visualiza el rendimiento de tu negocio",
    period_7d: "7 días",
    period_30d: "30 días",
    period_90d: "90 días",
    trend_chart_title: "Quejas y Sugerencias por día",
    status_chart_title: "Distribución por Estado",
    total_in_period: "Total en período",
    no_data: "Sin datos para el período seleccionado",
    complaints_label: "Quejas",
    suggestions_label: "Sugerencias",
    
    // Misc
    remove: "Quitar",
    or: "o",
    back: "Volver",
    anonymous: "Anónimo",

    // Landing Page
    lp_nav_how: "Cómo funciona",
    lp_nav_pricing: "Precios",
    lp_nav_download: "Descargar App",
    lp_nav_login: "Iniciar sesión",
    lp_nav_cta: "Probar gratis",
    lp_hero_title: "Evita malas reseñas en Google",
    lp_hero_highlight: "antes de que ocurran",
    lp_hero_desc: "Captura las quejas de tus clientes directamente en tu negocio con un código QR simple. Ellos se desahogan contigo, no en internet.",
    lp_hero_cta: "Comenzar gratis",
    lp_hero_how: "Ver cómo funciona",
    lp_hero_badge: "Queja recibida en privado",
    lp_problem_label: "El problema",
    lp_problem_title: "Tus clientes insatisfechos no se quejan contigo...",
    lp_problem_stat_text: "de los clientes insatisfechos nunca se quejan directamente. Simplemente no regresan y dejan una mala reseña en Google.",
    lp_problem_card1_title: "Clientes que se van en silencio",
    lp_problem_card1_desc: "No te dicen qué les molestó. Solo no regresan y tú nunca sabes por qué.",
    lp_problem_card2_title: "Reseñas negativas públicas",
    lp_problem_card2_desc: "En lugar de decírtelo a ti, lo publican en Google para que todos lo vean.",
    lp_problem_card3_title: "Pérdida de reputación",
    lp_problem_card3_desc: "Cada mala reseña aleja a nuevos clientes potenciales de tu negocio.",
    lp_solution_label: "La solución",
    lp_solution_title: "Así de simple funciona SUCO",
    lp_solution_subtitle: "En 3 pasos, conviertes a un cliente enojado en un cliente que regresa",
    lp_step1_title: "El cliente escanea el QR",
    lp_step1_desc: "Colocas el código QR en mesas, mostrador o recibos. No necesita instalar nada.",
    lp_step2_title: "Deja su comentario en privado",
    lp_step2_desc: "Se desahoga directamente contigo en segundos. Se siente escuchado y valorado.",
    lp_step3_title: "Tú recibes la alerta al instante",
    lp_step3_desc: "Te llega un correo inmediato. Puedes actuar rápido y recuperar al cliente.",
    lp_benefits_label: "Beneficios",
    lp_benefits_title: "Todo lo que necesitas para proteger tu negocio",
    lp_benefit1_title: "Evita malas reseñas",
    lp_benefit1_desc: "Las quejas te llegan a ti antes de que lleguen a Google Maps o redes sociales.",
    lp_benefit2_title: "Recupera clientes",
    lp_benefit2_desc: "Actúa rápido ante un problema y convierte una mala experiencia en lealtad.",
    lp_benefit3_title: "Mejora tu servicio",
    lp_benefit3_desc: "Recibe información real y directa de tus clientes para mejorar continuamente.",
    lp_benefit4_title: "Fácil de usar, funciona en minutos",
    lp_benefit4_desc: "Sin instalaciones, sin apps. Solo regístrate, imprime tu QR y listo.",
    lp_benefit5_title: "9 idiomas incluidos",
    lp_benefit5_desc: "Tus clientes pueden dejar su comentario en su idioma preferido.",
    lp_benefit6_title: "QR con tu logo",
    lp_benefit6_desc: "Personaliza el código QR con el logo de tu negocio para mayor confianza.",
    lp_new: "Nuevo",
    lp_wifi_title: "QR de WiFi para clientes",
    lp_wifi_desc: "Genera un código QR para que tus clientes se conecten fácilmente a tu red WiFi. Opcional y con el logo de tu negocio.",
    lp_pricing_label: "Precios",
    lp_pricing_title: "Simple y transparente",
    lp_pricing_subtitle: "Empieza con 7 días gratis. Sin contratos, cancela cuando quieras.",
    lp_pricing_business: "Para tu negocio",
    lp_pricing_monthly: "Plan Mensual",
    lp_pricing_yearly: "Plan Anual",
    lp_pricing_save: "Ahorra 29%",
    lp_pricing_f1: "QR ilimitados",
    lp_pricing_f2: "Alertas en tiempo real",
    lp_pricing_f3: "Panel de analíticas",
    lp_pricing_f4: "9 idiomas",
    lp_pricing_f5: "Soporte por correo",
    lp_pricing_yf1: "Todo lo del plan mensual",
    lp_pricing_yf2: "Ahorro de $45.88 al año",
    lp_pricing_yf3: "Soporte prioritario",
    lp_pricing_yf4: "QR con logo personalizado",
    lp_pricing_yf5: "Carteles PDF y DOCX",
    lp_pricing_enterprise_label: "Para negocios con sucursales",
    lp_pricing_enterprise_badge: "Multi-sucursal",
    lp_pricing_enterprise: "Plan Empresarial",
    lp_pricing_enterprise_extra: "+ $5.99/mes por cada sucursal adicional",
    lp_pricing_ef1: "1 sucursal incluida",
    lp_pricing_ef2: "Dashboard centralizado",
    lp_pricing_ef3: "Email independiente por sucursal",
    lp_pricing_ef4: "QR único por sucursal",
    lp_pricing_ef5: "Analytics comparativos",
    lp_pricing_ef6: "Soporte prioritario",
    lp_pricing_example: "Ejemplo: 17 sucursales = $125.83/mes o $1,243/año",
    lp_pricing_contact: "Contactar ventas",
    lp_pricing_trial: "7 días de prueba gratis incluidos en todos los planes",
    lp_trust_title: "Ideal para negocios que quieren cuidar su reputación",
    lp_trust_desc: "SUCO está diseñado para cualquier negocio donde la experiencia del cliente importa.",
    lp_trust_tags: "Restaurantes,Cafeterías,Estéticas,Talleres mecánicos,Veterinarias,Consultorios,Gimnasios,Hoteles",
    lp_download_title: "Descarga SUCO en tu dispositivo",
    lp_download_desc: "Instala SUCO como aplicación. Sin tienda de apps, sin esperas.",
    lp_download_btn: "Instalar SUCO",
    lp_download_desktop: "En computadora (Chrome)",
    lp_download_android: "En Android (Chrome)",
    lp_download_ios: "En iPhone / iPad (Safari)",
    lp_download_d1: "Abre sucomx.com en Google Chrome",
    lp_download_d2: "Haz clic en el ícono de instalar en la barra de direcciones",
    lp_download_d3: "Confirma con \"Instalar\"",
    lp_download_a1: "Abre sucomx.com en Chrome",
    lp_download_a2: "Toca el menú (tres puntos) arriba a la derecha",
    lp_download_a3: "Selecciona \"Instalar aplicación\"",
    lp_download_i1: "Abre sucomx.com en Safari",
    lp_download_i2: "Toca Compartir",
    lp_download_i3: "Selecciona \"Agregar a pantalla de inicio\"",
    lp_cta_title: "Empieza hoy y evita perder clientes sin saber por qué",
    lp_cta_desc: "Regístrate en menos de 2 minutos. Sin tarjeta de crédito requerida.",
    lp_cta_btn: "Comenzar ahora",
    lp_footer: "Sistema de retroalimentación con QR. Todos los derechos reservados."
  },
  
  en: {
    landing_subtitle: "Your voice matters.",
    landing_description: "Share your experiences and improve the service.",
    btn_get_started: "Get Started",
    btn_have_account: "I have an account",
    register_title: "Register your business",
    register_subtitle: "Create your account and get your personalized QR",
    business_name: "Business name",
    email: "Email",
    phone: "Phone (optional)",
    password: "Password",
    poster_language: "Poster language",
    your_logo: "Your logo (optional)",
    upload_file: "Upload file",
    logo_url: "Logo URL",
    logo_hint: "JPG, PNG or WEBP (max 5MB). Leave empty to use SUCO logo",
    btn_start_trial: "Start 7-day free trial",
    registering: "Registering...",
    register_success: "Business registered! You have 7 days free trial",
    login_title: "Log in",
    btn_login: "Log in",
    logging_in: "Logging in...",
    no_account: "Don't have an account?",
    sign_up: "Sign up",
    welcome_back: "Welcome back!",
    dashboard_subtitle: "Admin panel",
    tab_overview: "Overview",
    tab_complaints: "Complaints & Suggestions",
    tab_qr: "My QR",
    btn_logout: "Logout",
    free_trial: "Free trial",
    stat_total: "Total",
    stat_pending: "Pending",
    stat_resolved: "Resolved",
    stat_complaints: "Complaints",
    stat_suggestions: "Suggestions",
    no_messages: "No messages yet",
    share_qr: "Share your QR to receive feedback",
    complaint: "Complaint",
    suggestion: "Suggestion",
    change_status: "Change status",
    status_pending: "Pending",
    status_in_progress: "In progress",
    status_resolved: "Resolved",
    status_closed: "Closed",
    qr_title: "Your personalized QR code",
    qr_subtitle: "Share it with your customers to receive feedback",
    public_url: "Public URL:",
    download_qr: "Download QR",
    download_pdf: "Download PDF",
    download_docx: "Download DOCX",
    wifi_qr_title: "WiFi QR Code",
    wifi_qr_subtitle: "Generate a QR code so your customers can connect to your WiFi",
    wifi_network_name: "Network name",
    wifi_password: "Password",
    wifi_password_placeholder: "Leave empty if no password",
    wifi_security: "Security type",
    wifi_no_password: "No password",
    wifi_generate_btn: "Generate WiFi QR",
    wifi_qr_generated: "WiFi QR code generated successfully",
    wifi_ssid_required: "Network name is required",
    wifi_download_qr: "Download WiFi QR",
    tab_branches: "Branches",
    branches_title: "WiFi by Branch",
    branches_subtitle: "Generate an independent WiFi QR for each of your branches",
    branches_no_branches: "No branches registered yet. Add them from your enterprise account.",
    branch_label: "Branch",
    branch_wifi_for: "Branch WiFi",
    regenerate_qr: "Regenerate QR",
    qr_regenerated: "QR and posters regenerated successfully",
    feedback_question: "What is your complaint or suggestion?",
    category: "Category",
    describe_problem: "Describe the problem or your suggestion",
    tell_us: "Tell us about your experience...",
    name_optional: "Name (optional)",
    email_optional: "Email (optional)",
    phone_optional: "Phone (optional)",
    btn_send: "Send",
    btn_clear: "Clear",
    sending: "Sending...",
    thank_you: "Thank you!",
    message_sent: "Your message has been sent successfully.",
    send_another: "Send another",
    powered_by: "Powered by SUCO",
    choose_plan: "Choose your plan",
    plan_subtitle: "Enjoy 7 free days, then choose the plan that suits you best",
    monthly: "Monthly Plan",
    yearly: "Yearly Plan",
    savings: "savings",
    btn_subscribe: "Subscribe",
    processing: "Processing...",
    per_year: "/year",
    per_month: "/month",
    loading_plans: "Loading plans...",
    verifying_payment: "Verifying payment...",
    wait_confirmation: "Please wait while we confirm your payment",
    payment_success: "Payment successful!",
    subscription_active: "Your subscription is active",
    trial_banner: "Free trial: {days} days remaining",
    trial_banner_last_day: "Free trial: last day",
    trial_expired: "Your free trial has expired",
    trial_expired_msg: "Subscribe to continue using SUCO",
    cancel_subscription: "Cancel subscription",
    cancel_confirm: "Are you sure? You will lose access at the end of your billing period",
    subscription_cancelled: "Subscription cancelled successfully",
    go_dashboard: "Go to Dashboard",
    payment_error: "Payment error",
    payment_confirm_error: "We couldn't confirm your payment",
    try_again: "Try again",
    your_name: "Your name",
    email_placeholder: "email@example.com",
    phone_placeholder: "+1 555 123 4567",
    error_payment: "Error starting payment",
    business_not_found: "Business not found",
    back_home: "Back to home",
    loading: "Loading...",
    error_loading: "Error loading data",
    invalid_credentials: "Invalid credentials",
    error_registering: "Error registering",
    error_sending: "Error sending",
    status_updated: "Status updated",
    tab_profile: "My Profile",
    profile_title: "Edit Profile",
    profile_subtitle: "Update your business information",
    email_cc: "CC Email (notifications)",
    email_cc_hint: "This email will also receive complaint and suggestion notifications",
    change_logo: "Change logo",
    save_changes: "Save changes",
    support: "Support",
    download_email_template: "Download sales email (Word)",
    profile_updated: "Profile updated successfully",
    error_updating: "Error updating profile",
    current_logo: "Current logo",
    no_logo: "No custom logo",
    tab_analytics: "Analytics",
    analytics_title: "Trend Analysis",
    analytics_subtitle: "Visualize your business performance",
    period_7d: "7 days",
    period_30d: "30 days",
    period_90d: "90 days",
    trend_chart_title: "Complaints and Suggestions per day",
    status_chart_title: "Distribution by Status",
    total_in_period: "Total in period",
    no_data: "No data for the selected period",
    complaints_label: "Complaints",
    suggestions_label: "Suggestions",
    remove: "Remove",
    or: "or",
    back: "Back",
    anonymous: "Anonymous",

    // Landing Page
    lp_nav_how: "How it works",
    lp_nav_pricing: "Pricing",
    lp_nav_download: "Download App",
    lp_nav_login: "Log in",
    lp_nav_cta: "Try free",
    lp_hero_title: "Prevent bad Google reviews",
    lp_hero_highlight: "before they happen",
    lp_hero_desc: "Capture your customers' complaints directly at your business with a simple QR code. They vent to you, not on the internet.",
    lp_hero_cta: "Start free",
    lp_hero_how: "See how it works",
    lp_hero_badge: "Complaint received privately",
    lp_problem_label: "The problem",
    lp_problem_title: "Your unhappy customers don't complain to you...",
    lp_problem_stat_text: "of unhappy customers never complain directly. They simply don't come back and leave a bad review on Google.",
    lp_problem_card1_title: "Customers who leave silently",
    lp_problem_card1_desc: "They don't tell you what bothered them. They just don't come back and you never know why.",
    lp_problem_card2_title: "Public negative reviews",
    lp_problem_card2_desc: "Instead of telling you, they post it on Google for everyone to see.",
    lp_problem_card3_title: "Loss of reputation",
    lp_problem_card3_desc: "Every bad review drives potential new customers away from your business.",
    lp_solution_label: "The solution",
    lp_solution_title: "This is how simple SUCO works",
    lp_solution_subtitle: "In 3 steps, turn an angry customer into a returning one",
    lp_step1_title: "Customer scans the QR",
    lp_step1_desc: "Place the QR code on tables, counters or receipts. No app install needed.",
    lp_step2_title: "Leaves their feedback privately",
    lp_step2_desc: "They vent directly to you in seconds. They feel heard and valued.",
    lp_step3_title: "You get the alert instantly",
    lp_step3_desc: "You receive an email immediately. You can act fast and recover the customer.",
    lp_benefits_label: "Benefits",
    lp_benefits_title: "Everything you need to protect your business",
    lp_benefit1_title: "Prevent bad reviews",
    lp_benefit1_desc: "Complaints come to you before they reach Google Maps or social media.",
    lp_benefit2_title: "Win back customers",
    lp_benefit2_desc: "Act fast on problems and turn a bad experience into loyalty.",
    lp_benefit3_title: "Improve your service",
    lp_benefit3_desc: "Get real, direct feedback from your customers to continuously improve.",
    lp_benefit4_title: "Easy to use, works in minutes",
    lp_benefit4_desc: "No installations, no apps. Just sign up, print your QR and go.",
    lp_benefit5_title: "9 languages included",
    lp_benefit5_desc: "Your customers can leave feedback in their preferred language.",
    lp_benefit6_title: "QR with your logo",
    lp_benefit6_desc: "Customize the QR code with your business logo for more trust.",
    lp_new: "New",
    lp_wifi_title: "WiFi QR for customers",
    lp_wifi_desc: "Generate a QR code so your customers can easily connect to your WiFi network. Optional and with your business logo.",
    lp_pricing_label: "Pricing",
    lp_pricing_title: "Simple and transparent",
    lp_pricing_subtitle: "Start with 7 free days. No contracts, cancel anytime.",
    lp_pricing_business: "For your business",
    lp_pricing_monthly: "Monthly Plan",
    lp_pricing_yearly: "Annual Plan",
    lp_pricing_save: "Save 29%",
    lp_pricing_f1: "Unlimited QR codes",
    lp_pricing_f2: "Real-time alerts",
    lp_pricing_f3: "Analytics dashboard",
    lp_pricing_f4: "9 languages",
    lp_pricing_f5: "Email support",
    lp_pricing_yf1: "Everything in monthly plan",
    lp_pricing_yf2: "Save $45.88 per year",
    lp_pricing_yf3: "Priority support",
    lp_pricing_yf4: "QR with custom logo",
    lp_pricing_yf5: "PDF and DOCX posters",
    lp_pricing_enterprise_label: "For multi-location businesses",
    lp_pricing_enterprise_badge: "Multi-branch",
    lp_pricing_enterprise: "Enterprise Plan",
    lp_pricing_enterprise_extra: "+ $5.99/month per additional branch",
    lp_pricing_ef1: "1 branch included",
    lp_pricing_ef2: "Centralized dashboard",
    lp_pricing_ef3: "Independent email per branch",
    lp_pricing_ef4: "Unique QR per branch",
    lp_pricing_ef5: "Comparative analytics",
    lp_pricing_ef6: "Priority support",
    lp_pricing_example: "Example: 17 branches = $125.83/mo or $1,243/year",
    lp_pricing_contact: "Contact sales",
    lp_pricing_trial: "7-day free trial included in all plans",
    lp_trust_title: "Ideal for businesses that care about their reputation",
    lp_trust_desc: "SUCO is designed for any business where customer experience matters.",
    lp_trust_tags: "Restaurants,Cafes,Beauty salons,Auto shops,Vet clinics,Medical offices,Gyms,Hotels",
    lp_download_title: "Download SUCO on your device",
    lp_download_desc: "Install SUCO as an app. No app store, no waiting.",
    lp_download_btn: "Install SUCO",
    lp_download_desktop: "On computer (Chrome)",
    lp_download_android: "On Android (Chrome)",
    lp_download_ios: "On iPhone / iPad (Safari)",
    lp_download_d1: "Open sucomx.com in Google Chrome",
    lp_download_d2: "Click the install icon in the address bar",
    lp_download_d3: "Confirm with \"Install\"",
    lp_download_a1: "Open sucomx.com in Chrome",
    lp_download_a2: "Tap the menu (three dots) at top right",
    lp_download_a3: "Select \"Install app\"",
    lp_download_i1: "Open sucomx.com in Safari",
    lp_download_i2: "Tap Share",
    lp_download_i3: "Select \"Add to Home Screen\"",
    lp_cta_title: "Start today and stop losing customers without knowing why",
    lp_cta_desc: "Sign up in less than 2 minutes. No credit card required.",
    lp_cta_btn: "Get started now",
    lp_footer: "QR feedback system. All rights reserved."
  },
  
  pt: {
    landing_subtitle: "Sua voz importa.",
    landing_description: "Compartilhe suas experiências e melhore o serviço.",
    btn_get_started: "Começar",
    btn_have_account: "Já tenho conta",
    register_title: "Registre seu negócio",
    register_subtitle: "Crie sua conta e obtenha seu QR personalizado",
    business_name: "Nome do negócio",
    email: "E-mail",
    phone: "Telefone (opcional)",
    password: "Senha",
    poster_language: "Idioma do cartaz",
    your_logo: "Seu logo (opcional)",
    upload_file: "Enviar arquivo",
    logo_url: "URL do logo",
    logo_hint: "JPG, PNG ou WEBP (máx 5MB). Deixe vazio para usar o logo do SUCO",
    btn_start_trial: "Iniciar teste grátis de 7 dias",
    registering: "Registrando...",
    register_success: "Negócio registrado! Você tem 7 dias de teste grátis",
    login_title: "Entrar",
    btn_login: "Entrar",
    logging_in: "Entrando...",
    no_account: "Não tem conta?",
    sign_up: "Cadastre-se",
    welcome_back: "Bem-vindo de volta!",
    dashboard_subtitle: "Painel de administração",
    tab_overview: "Resumo",
    tab_complaints: "Reclamações e Sugestões",
    tab_qr: "Meu QR",
    btn_logout: "Sair",
    free_trial: "Teste grátis",
    stat_total: "Total",
    stat_pending: "Pendentes",
    stat_resolved: "Resolvidos",
    stat_complaints: "Reclamações",
    stat_suggestions: "Sugestões",
    no_messages: "Sem mensagens ainda",
    share_qr: "Compartilhe seu QR para receber feedback",
    complaint: "Reclamação",
    suggestion: "Sugestão",
    change_status: "Alterar status",
    status_pending: "Pendente",
    status_in_progress: "Em andamento",
    status_resolved: "Resolvido",
    status_closed: "Fechado",
    qr_title: "Seu código QR personalizado",
    qr_subtitle: "Compartilhe com seus clientes para receber feedback",
    public_url: "URL pública:",
    download_qr: "Baixar QR",
    download_pdf: "Baixar PDF",
    download_docx: "Baixar DOCX",
    wifi_qr_title: "QR de WiFi",
    wifi_qr_subtitle: "Gere um QR para seus clientes se conectarem ao seu WiFi",
    wifi_network_name: "Nome da rede",
    wifi_password: "Senha",
    wifi_password_placeholder: "Deixe vazio se não tiver senha",
    wifi_security: "Tipo de segurança",
    wifi_no_password: "Sem senha",
    wifi_generate_btn: "Gerar QR de WiFi",
    wifi_qr_generated: "QR de WiFi gerado com sucesso",
    wifi_ssid_required: "O nome da rede é obrigatório",
    wifi_download_qr: "Baixar QR de WiFi",
    regenerate_qr: "Regenerar QR",
    qr_regenerated: "QR e cartazes regenerados com sucesso",
    feedback_question: "Qual é sua reclamação ou sugestão?",
    category: "Categoria",
    describe_problem: "Descreva o problema ou sua sugestão",
    tell_us: "Conte-nos sua experiência...",
    name_optional: "Nome (opcional)",
    email_optional: "E-mail (opcional)",
    phone_optional: "Telefone (opcional)",
    btn_send: "Enviar",
    btn_clear: "Limpar",
    sending: "Enviando...",
    thank_you: "Obrigado!",
    message_sent: "Sua mensagem foi enviada com sucesso.",
    send_another: "Enviar outro",
    powered_by: "Powered by SUCO",
    choose_plan: "Escolha seu plano",
    plan_subtitle: "Aproveite 7 dias grátis, depois escolha o plano ideal",
    monthly: "Plano Mensal",
    yearly: "Plano Anual",
    savings: "de economia",
    btn_subscribe: "Assinar",
    processing: "Processando...",
    per_year: "/ano",
    per_month: "/mês",
    loading_plans: "Carregando planos...",
    verifying_payment: "Verificando pagamento...",
    wait_confirmation: "Aguarde enquanto confirmamos seu pagamento",
    payment_success: "Pagamento realizado!",
    subscription_active: "Sua assinatura está ativa",
    trial_banner: "Teste grátis: restam {days} dias",
    trial_banner_last_day: "Teste grátis: último dia",
    trial_expired: "Seu teste grátis expirou",
    trial_expired_msg: "Assine para continuar usando o SUCO",
    cancel_subscription: "Cancelar assinatura",
    cancel_confirm: "Tem certeza? Você perderá o acesso no final do período de pagamento",
    subscription_cancelled: "Assinatura cancelada com sucesso",
    go_dashboard: "Ir ao Dashboard",
    payment_error: "Erro no pagamento",
    payment_confirm_error: "Não foi possível confirmar seu pagamento",
    try_again: "Tentar novamente",
    your_name: "Seu nome",
    email_placeholder: "email@exemplo.com",
    phone_placeholder: "+55 11 9999 9999",
    error_payment: "Erro ao iniciar pagamento",
    business_not_found: "Negócio não encontrado",
    back_home: "Voltar ao início",
    loading: "Carregando...",
    error_loading: "Erro ao carregar dados",
    invalid_credentials: "Credenciais inválidas",
    error_registering: "Erro ao registrar",
    error_sending: "Erro ao enviar",
    status_updated: "Status atualizado",
    tab_profile: "Meu Perfil",
    profile_title: "Editar Perfil",
    profile_subtitle: "Atualize as informações do seu negócio",
    email_cc: "Email CC (notificações)",
    email_cc_hint: "Este email também receberá as notificações de reclamações e sugestões",
    change_logo: "Alterar logo",
    save_changes: "Salvar alterações",
    support: "Suporte",
    download_email_template: "Baixar email comercial (Word)",
    saving: "Salvando...",
    profile_updated: "Perfil atualizado com sucesso",
    error_updating: "Erro ao atualizar o perfil",
    current_logo: "Logo atual",
    no_logo: "Sem logo personalizado",
    tab_analytics: "Analytics",
    analytics_title: "Análise de Tendências",
    analytics_subtitle: "Visualize o desempenho do seu negócio",
    period_7d: "7 dias",
    period_30d: "30 dias",
    period_90d: "90 dias",
    trend_chart_title: "Reclamações e Sugestões por dia",
    status_chart_title: "Distribuição por Status",
    total_in_period: "Total no período",
    no_data: "Sem dados para o período selecionado",
    complaints_label: "Reclamações",
    suggestions_label: "Sugestões",
    remove: "Remover",
    or: "ou",
    back: "Voltar",
    anonymous: "Anônimo",

    // Landing Page
    lp_nav_how: "Como funciona",
    lp_nav_pricing: "Precos",
    lp_nav_download: "Baixar App",
    lp_nav_login: "Entrar",
    lp_nav_cta: "Testar gratis",
    lp_hero_title: "Evite avaliacoes negativas no Google",
    lp_hero_highlight: "antes que acontecam",
    lp_hero_desc: "Capture as reclamacoes dos seus clientes diretamente no seu negocio com um QR code simples. Eles desabafam com voce, nao na internet.",
    lp_hero_cta: "Comecar gratis",
    lp_hero_how: "Veja como funciona",
    lp_hero_badge: "Reclamacao recebida em privado",
    lp_problem_label: "O problema",
    lp_problem_title: "Seus clientes insatisfeitos nao reclamam com voce...",
    lp_problem_stat_text: "dos clientes insatisfeitos nunca reclamam diretamente. Simplesmente nao voltam e deixam uma avaliacao negativa no Google.",
    lp_problem_card1_title: "Clientes que vao embora em silencio",
    lp_problem_card1_desc: "Nao te dizem o que incomodou. Simplesmente nao voltam e voce nunca sabe por que.",
    lp_problem_card2_title: "Avaliacoes negativas publicas",
    lp_problem_card2_desc: "Em vez de falar com voce, publicam no Google para todos verem.",
    lp_problem_card3_title: "Perda de reputacao",
    lp_problem_card3_desc: "Cada avaliacao negativa afasta novos clientes potenciais do seu negocio.",
    lp_solution_label: "A solucao",
    lp_solution_title: "E assim de simples que o SUCO funciona",
    lp_solution_subtitle: "Em 3 passos, transforme um cliente irritado em um que volta",
    lp_step1_title: "O cliente escaneia o QR",
    lp_step1_desc: "Coloque o QR code em mesas, balcao ou recibos. Nao precisa instalar nada.",
    lp_step2_title: "Deixa seu comentario em privado",
    lp_step2_desc: "Desabafa diretamente com voce em segundos. Se sente ouvido e valorizado.",
    lp_step3_title: "Voce recebe o alerta na hora",
    lp_step3_desc: "Recebe um email imediato. Pode agir rapido e recuperar o cliente.",
    lp_benefits_label: "Beneficios",
    lp_benefits_title: "Tudo que voce precisa para proteger seu negocio",
    lp_benefit1_title: "Evite avaliacoes negativas",
    lp_benefit1_desc: "As reclamacoes chegam a voce antes de chegarem ao Google Maps ou redes sociais.",
    lp_benefit2_title: "Recupere clientes",
    lp_benefit2_desc: "Aja rapido diante de um problema e transforme uma experiencia ruim em fidelidade.",
    lp_benefit3_title: "Melhore seu servico",
    lp_benefit3_desc: "Receba informacoes reais e diretas dos seus clientes para melhorar continuamente.",
    lp_benefit4_title: "Facil de usar, funciona em minutos",
    lp_benefit4_desc: "Sem instalacoes, sem apps. So cadastre-se, imprima seu QR e pronto.",
    lp_benefit5_title: "9 idiomas incluidos",
    lp_benefit5_desc: "Seus clientes podem deixar comentarios no idioma preferido.",
    lp_benefit6_title: "QR com seu logo",
    lp_benefit6_desc: "Personalize o QR code com o logo do seu negocio para mais confianca.",
    lp_new: "Novo",
    lp_wifi_title: "QR de WiFi para clientes",
    lp_wifi_desc: "Gere um QR para que seus clientes se conectem facilmente ao seu WiFi. Opcional e com o logo do seu negócio.",
    lp_pricing_label: "Precos",
    lp_pricing_title: "Simples e transparente",
    lp_pricing_subtitle: "Comece com 7 dias gratis. Sem contratos, cancele quando quiser.",
    lp_pricing_business: "Para seu negocio",
    lp_pricing_monthly: "Plano Mensal",
    lp_pricing_yearly: "Plano Anual",
    lp_pricing_save: "Economize 29%",
    lp_pricing_f1: "QR ilimitados",
    lp_pricing_f2: "Alertas em tempo real",
    lp_pricing_f3: "Painel de analiticas",
    lp_pricing_f4: "9 idiomas",
    lp_pricing_f5: "Suporte por email",
    lp_pricing_yf1: "Tudo do plano mensal",
    lp_pricing_yf2: "Economize $45.88 por ano",
    lp_pricing_yf3: "Suporte prioritario",
    lp_pricing_yf4: "QR com logo personalizado",
    lp_pricing_yf5: "Cartazes PDF e DOCX",
    lp_pricing_enterprise_label: "Para negocios com filiais",
    lp_pricing_enterprise_badge: "Multi-filial",
    lp_pricing_enterprise: "Plano Empresarial",
    lp_pricing_enterprise_extra: "+ $5.99/mes por filial adicional",
    lp_pricing_ef1: "1 filial incluida",
    lp_pricing_ef2: "Dashboard centralizado",
    lp_pricing_ef3: "Email independente por filial",
    lp_pricing_ef4: "QR unico por filial",
    lp_pricing_ef5: "Analiticas comparativas",
    lp_pricing_ef6: "Suporte prioritario",
    lp_pricing_example: "Exemplo: 17 filiais = $125.83/mes ou $1.243/ano",
    lp_pricing_contact: "Contatar vendas",
    lp_pricing_trial: "7 dias de teste gratis incluidos em todos os planos",
    lp_trust_title: "Ideal para negocios que cuidam da sua reputacao",
    lp_trust_desc: "SUCO e projetado para qualquer negocio onde a experiencia do cliente importa.",
    lp_trust_tags: "Restaurantes,Cafeterias,Saloes,Oficinas,Veterinarias,Consultorios,Academias,Hoteis",
    lp_download_title: "Baixe o SUCO no seu dispositivo",
    lp_download_desc: "Instale o SUCO como aplicativo. Sem loja de apps, sem espera.",
    lp_download_btn: "Instalar SUCO",
    lp_download_desktop: "No computador (Chrome)",
    lp_download_android: "No Android (Chrome)",
    lp_download_ios: "No iPhone / iPad (Safari)",
    lp_download_d1: "Abra sucomx.com no Google Chrome",
    lp_download_d2: "Clique no icone de instalar na barra de endereco",
    lp_download_d3: "Confirme com \"Instalar\"",
    lp_download_a1: "Abra sucomx.com no Chrome",
    lp_download_a2: "Toque no menu (tres pontos) no canto superior direito",
    lp_download_a3: "Selecione \"Instalar aplicativo\"",
    lp_download_i1: "Abra sucomx.com no Safari",
    lp_download_i2: "Toque em Compartilhar",
    lp_download_i3: "Selecione \"Adicionar a Tela de Inicio\"",
    lp_cta_title: "Comece hoje e pare de perder clientes sem saber por que",
    lp_cta_desc: "Cadastre-se em menos de 2 minutos. Sem cartao de credito.",
    lp_cta_btn: "Comecar agora",
    lp_footer: "Sistema de feedback por QR. Todos os direitos reservados."
  },
  
  zh: {
    landing_subtitle: "您的声音很重要。",
    landing_description: "分享您的体验，改善服务。",
    btn_get_started: "开始",
    btn_have_account: "我已有账户",
    register_title: "注册您的企业",
    register_subtitle: "创建账户并获取个性化二维码",
    business_name: "企业名称",
    email: "电子邮箱",
    phone: "电话（可选）",
    password: "密码",
    poster_language: "海报语言",
    your_logo: "您的标志（可选）",
    upload_file: "上传文件",
    logo_url: "标志网址",
    logo_hint: "JPG、PNG或WEBP（最大5MB）。留空使用SUCO标志",
    btn_start_trial: "开始7天免费试用",
    registering: "注册中...",
    register_success: "企业已注册！您有7天免费试用",
    login_title: "登录",
    btn_login: "登录",
    logging_in: "登录中...",
    no_account: "没有账户？",
    sign_up: "注册",
    welcome_back: "欢迎回来！",
    dashboard_subtitle: "管理面板",
    tab_overview: "概览",
    tab_complaints: "投诉与建议",
    tab_qr: "我的二维码",
    btn_logout: "退出",
    free_trial: "免费试用",
    stat_total: "总计",
    stat_pending: "待处理",
    stat_resolved: "已解决",
    stat_complaints: "投诉",
    stat_suggestions: "建议",
    no_messages: "暂无消息",
    share_qr: "分享二维码以获取反馈",
    complaint: "投诉",
    suggestion: "建议",
    change_status: "更改状态",
    status_pending: "待处理",
    status_in_progress: "处理中",
    status_resolved: "已解决",
    status_closed: "已关闭",
    qr_title: "您的个性化二维码",
    qr_subtitle: "与客户分享以获取反馈",
    public_url: "公开网址：",
    download_qr: "下载二维码",
    download_pdf: "下载PDF",
    download_docx: "下载DOCX",
    wifi_qr_title: "WiFi二维码",
    wifi_qr_subtitle: "生成二维码让您的客户连接到您的WiFi",
    wifi_network_name: "网络名称",
    wifi_password: "密码",
    wifi_password_placeholder: "没有密码则留空",
    wifi_security: "安全类型",
    wifi_no_password: "无密码",
    wifi_generate_btn: "生成WiFi二维码",
    wifi_qr_generated: "WiFi二维码已生成",
    wifi_ssid_required: "网络名称为必填项",
    wifi_download_qr: "下载WiFi二维码",
    tab_branches: "分店",
    branches_title: "分店WiFi",
    branches_subtitle: "为每个分店生成独立的WiFi二维码",
    branches_no_branches: "尚未注册分店。请通过企业账户添加。",
    branch_label: "分店",
    branch_wifi_for: "分店WiFi",
    regenerate_qr: "重新生成QR",
    qr_regenerated: "QR码和海报已成功重新生成",
    feedback_question: "您有什么投诉或建议？",
    category: "类别",
    describe_problem: "描述问题或您的建议",
    tell_us: "告诉我们您的体验...",
    name_optional: "姓名（可选）",
    email_optional: "电子邮箱（可选）",
    phone_optional: "电话（可选）",
    btn_send: "发送",
    btn_clear: "清除",
    sending: "发送中...",
    thank_you: "谢谢！",
    message_sent: "您的消息已成功发送。",
    send_another: "再发一条",
    powered_by: "由SUCO提供支持",
    choose_plan: "选择您的计划",
    plan_subtitle: "享受7天免费，然后选择最适合您的计划",
    monthly: "月度计划",
    yearly: "年度计划",
    savings: "节省",
    btn_subscribe: "订阅",
    processing: "处理中...",
    per_year: "/年",
    per_month: "/月",
    loading_plans: "加载方案...",
    verifying_payment: "验证支付...",
    wait_confirmation: "请稍候，我们正在确认您的付款",
    payment_success: "支付成功！",
    subscription_active: "您的订阅已激活",
    trial_banner: "免费试用：剩余 {days} 天",
    trial_banner_last_day: "免费试用：最后一天",
    trial_expired: "您的免费试用已过期",
    trial_expired_msg: "订阅以继续使用 SUCO",
    cancel_subscription: "取消订阅",
    cancel_confirm: "确定吗？付费期结束后将失去访问权限",
    subscription_cancelled: "订阅已成功取消",
    go_dashboard: "进入控制台",
    payment_error: "支付错误",
    payment_confirm_error: "无法确认您的付款",
    try_again: "重试",
    your_name: "您的姓名",
    email_placeholder: "email@example.com",
    phone_placeholder: "+86 138 0000 0000",
    error_payment: "启动支付失败",
    business_not_found: "未找到企业",
    back_home: "返回首页",
    loading: "加载中...",
    error_loading: "加载数据出错",
    invalid_credentials: "凭据无效",
    error_registering: "注册出错",
    error_sending: "发送出错",
    status_updated: "状态已更新",
    tab_profile: "我的资料",
    profile_title: "编辑资料",
    profile_subtitle: "更新您的企业信息",
    email_cc: "抄送邮箱（通知）",
    email_cc_hint: "此邮箱也将收到投诉和建议的通知",
    change_logo: "更换标志",
    save_changes: "保存更改",
    support: "支持",
    download_email_template: "下载销售邮件 (Word)",
    saving: "保存中...",
    profile_updated: "资料更新成功",
    error_updating: "更新资料出错",
    current_logo: "当前标志",
    no_logo: "无自定义标志",
    tab_analytics: "分析",
    analytics_title: "趋势分析",
    analytics_subtitle: "可视化您的业务表现",
    period_7d: "7天",
    period_30d: "30天",
    period_90d: "90天",
    trend_chart_title: "每日投诉和建议",
    status_chart_title: "状态分布",
    total_in_period: "期间总计",
    no_data: "所选期间没有数据",
    complaints_label: "投诉",
    suggestions_label: "建议",
    remove: "移除",
    or: "或",
    back: "返回",
    anonymous: "匿名",

    // Landing Page
    lp_nav_how: "使用方法",
    lp_nav_pricing: "价格",
    lp_nav_download: "下载应用",
    lp_nav_login: "登录",
    lp_nav_cta: "免费试用",
    lp_hero_title: "防止Google差评",
    lp_hero_highlight: "在发生之前",
    lp_hero_desc: "通过简单的二维码直接在您的店铺中收集客户投诉。他们向您倾诉，而不是在网上发布。",
    lp_hero_cta: "免费开始",
    lp_hero_how: "了解如何运作",
    lp_hero_badge: "私密收到投诉",
    lp_problem_label: "问题",
    lp_problem_title: "您的不满意客户不会向您投诉...",
    lp_problem_stat_text: "的不满意客户从不直接投诉。他们只是不再光顾，然后在Google上留下差评。",
    lp_problem_card1_title: "默默离开的客户",
    lp_problem_card1_desc: "他们不会告诉你什么让他们不满。只是不再来，而你永远不知道为什么。",
    lp_problem_card2_title: "公开的负面评价",
    lp_problem_card2_desc: "他们不告诉你，而是发布在Google上让所有人看到。",
    lp_problem_card3_title: "声誉损失",
    lp_problem_card3_desc: "每一条差评都会让潜在新客户远离您的生意。",
    lp_solution_label: "解决方案",
    lp_solution_title: "SUCO就是这么简单",
    lp_solution_subtitle: "只需3步，将愤怒的客户变成回头客",
    lp_step1_title: "客户扫描二维码",
    lp_step1_desc: "将二维码放在桌子、柜台或收据上。无需安装任何应用。",
    lp_step2_title: "私密留下反馈",
    lp_step2_desc: "几秒钟内直接向您倾诉。感到被倾听和重视。",
    lp_step3_title: "您即时收到提醒",
    lp_step3_desc: "您会立即收到邮件通知。可以快速行动挽回客户。",
    lp_benefits_label: "优势",
    lp_benefits_title: "保护您生意所需的一切",
    lp_benefit1_title: "防止差评",
    lp_benefit1_desc: "投诉先到您这里，然后才到Google地图或社交媒体。",
    lp_benefit2_title: "挽回客户",
    lp_benefit2_desc: "快速解决问题，将糟糕体验转化为忠诚。",
    lp_benefit3_title: "改善服务",
    lp_benefit3_desc: "获取客户真实直接反馈，持续改进。",
    lp_benefit4_title: "简单易用，几分钟搞定",
    lp_benefit4_desc: "无需安装。注册、打印二维码即可。",
    lp_benefit5_title: "支持9种语言",
    lp_benefit5_desc: "您的客户可以用喜欢的语言留下反馈。",
    lp_benefit6_title: "带Logo二维码",
    lp_benefit6_desc: "用商业Logo自定义二维码，增加信任度。",
    lp_new: "新功能",
    lp_wifi_title: "客户WiFi二维码",
    lp_wifi_desc: "生成二维码让客户轻松连接您的WiFi网络。可选功能，带有您的商业Logo。",
    lp_pricing_label: "价格",
    lp_pricing_title: "简单透明",
    lp_pricing_subtitle: "7天免费试用。无合同，随时取消。",
    lp_pricing_business: "适合您的生意",
    lp_pricing_monthly: "月度计划",
    lp_pricing_yearly: "年度计划",
    lp_pricing_save: "节省29%",
    lp_pricing_f1: "无限二维码",
    lp_pricing_f2: "实时提醒",
    lp_pricing_f3: "分析面板",
    lp_pricing_f4: "9种语言",
    lp_pricing_f5: "邮件支持",
    lp_pricing_yf1: "包含月度所有功能",
    lp_pricing_yf2: "每年节省$45.88",
    lp_pricing_yf3: "优先支持",
    lp_pricing_yf4: "自定义Logo二维码",
    lp_pricing_yf5: "PDF和DOCX海报",
    lp_pricing_enterprise_label: "适合多门店企业",
    lp_pricing_enterprise_badge: "多门店",
    lp_pricing_enterprise: "企业计划",
    lp_pricing_enterprise_extra: "+ $5.99/月 每个额外门店",
    lp_pricing_ef1: "包含1个门店",
    lp_pricing_ef2: "集中管理面板",
    lp_pricing_ef3: "每个门店独立邮箱",
    lp_pricing_ef4: "每个门店独立二维码",
    lp_pricing_ef5: "对比分析",
    lp_pricing_ef6: "优先支持",
    lp_pricing_example: "示例：17个门店 = $125.83/月 或 $1,243/年",
    lp_pricing_contact: "联系销售",
    lp_pricing_trial: "所有计划均含7天免费试用",
    lp_trust_title: "适合注重声誉的企业",
    lp_trust_desc: "SUCO专为重视客户体验的企业设计。",
    lp_trust_tags: "餐厅,咖啡馆,美容院,汽修店,宠物医院,诊所,健身房,酒店",
    lp_download_title: "在设备上下载SUCO",
    lp_download_desc: "将SUCO安装为应用。无需应用商店。",
    lp_download_btn: "安装SUCO",
    lp_download_desktop: "电脑 (Chrome)",
    lp_download_android: "安卓 (Chrome)",
    lp_download_ios: "iPhone / iPad (Safari)",
    lp_download_d1: "在Chrome中打开sucomx.com",
    lp_download_d2: "点击地址栏中的安装图标",
    lp_download_d3: "确认安装",
    lp_download_a1: "在Chrome中打开sucomx.com",
    lp_download_a2: "点击右上角菜单",
    lp_download_a3: "选择安装应用",
    lp_download_i1: "在Safari中打开sucomx.com",
    lp_download_i2: "点击分享",
    lp_download_i3: "选择添加到主屏幕",
    lp_cta_title: "今天开始，不再不明不白地失去客户",
    lp_cta_desc: "2分钟内注册。无需信用卡。",
    lp_cta_btn: "立即开始",
    lp_footer: "二维码反馈系统。保留所有权利。"
  },
  
  ja: {
    landing_subtitle: "あなたの声が大切です。",
    landing_description: "体験を共有してサービスを改善しましょう。",
    btn_get_started: "始める",
    btn_have_account: "アカウントを持っています",
    register_title: "ビジネスを登録",
    register_subtitle: "アカウントを作成してカスタムQRを取得",
    business_name: "ビジネス名",
    email: "メールアドレス",
    phone: "電話番号（任意）",
    password: "パスワード",
    poster_language: "ポスターの言語",
    your_logo: "ロゴ（任意）",
    upload_file: "ファイルをアップロード",
    logo_url: "ロゴURL",
    logo_hint: "JPG、PNG、WEBP（最大5MB）。空欄でSUCOロゴを使用",
    btn_start_trial: "7日間の無料トライアルを開始",
    registering: "登録中...",
    register_success: "ビジネスが登録されました！7日間の無料トライアル",
    login_title: "ログイン",
    btn_login: "ログイン",
    logging_in: "ログイン中...",
    no_account: "アカウントをお持ちでないですか？",
    sign_up: "新規登録",
    welcome_back: "おかえりなさい！",
    dashboard_subtitle: "管理パネル",
    tab_overview: "概要",
    tab_complaints: "苦情と提案",
    tab_qr: "マイQR",
    btn_logout: "ログアウト",
    free_trial: "無料トライアル",
    stat_total: "合計",
    stat_pending: "保留中",
    stat_resolved: "解決済み",
    stat_complaints: "苦情",
    stat_suggestions: "提案",
    no_messages: "メッセージはまだありません",
    share_qr: "QRを共有してフィードバックを受け取る",
    complaint: "苦情",
    suggestion: "提案",
    change_status: "ステータス変更",
    status_pending: "保留中",
    status_in_progress: "進行中",
    status_resolved: "解決済み",
    status_closed: "クローズ",
    qr_title: "カスタムQRコード",
    qr_subtitle: "お客様と共有してフィードバックを受け取る",
    public_url: "公開URL：",
    download_qr: "QRをダウンロード",
    download_pdf: "PDFをダウンロード",
    download_docx: "DOCXをダウンロード",
    wifi_qr_title: "WiFi QRコード",
    wifi_qr_subtitle: "お客様がWiFiに接続できるQRコードを生成",
    wifi_network_name: "ネットワーク名",
    wifi_password: "パスワード",
    wifi_password_placeholder: "パスワードがない場合は空白",
    wifi_security: "セキュリティタイプ",
    wifi_no_password: "パスワードなし",
    wifi_generate_btn: "WiFi QRを生成",
    wifi_qr_generated: "WiFi QRコードが生成されました",
    wifi_ssid_required: "ネットワーク名は必須です",
    wifi_download_qr: "WiFi QRをダウンロード",
    tab_branches: "支店",
    branches_title: "支店ごとのWiFi",
    branches_subtitle: "各支店に独立したWiFi QRを生成します",
    branches_no_branches: "登録された支店はまだありません。エンタープライズアカウントから追加してください。",
    branch_label: "支店",
    branch_wifi_for: "支店のWiFi",
    regenerate_qr: "QR再生成",
    qr_regenerated: "QRとポスターが正常に再生成されました",
    feedback_question: "ご意見・ご要望はありますか？",
    category: "カテゴリ",
    describe_problem: "問題または提案を説明してください",
    tell_us: "体験を教えてください...",
    name_optional: "名前（任意）",
    email_optional: "メール（任意）",
    phone_optional: "電話番号（任意）",
    btn_send: "送信",
    btn_clear: "クリア",
    sending: "送信中...",
    thank_you: "ありがとうございます！",
    message_sent: "メッセージが正常に送信されました。",
    send_another: "別のメッセージを送信",
    powered_by: "Powered by SUCO",
    choose_plan: "プランを選択",
    plan_subtitle: "7日間無料でお試し、その後最適なプランを選択",
    monthly: "月額プラン",
    yearly: "年額プラン",
    savings: "お得",
    btn_subscribe: "登録",
    processing: "処理中...",
    per_year: "/年",
    per_month: "/月",
    loading_plans: "プラン読み込み中...",
    verifying_payment: "お支払いを確認中...",
    wait_confirmation: "お支払いの確認をお待ちください",
    payment_success: "お支払い完了！",
    subscription_active: "サブスクリプションが有効です",
    trial_banner: "無料トライアル：残り {days} 日",
    trial_banner_last_day: "無料トライアル：最終日",
    trial_expired: "無料トライアルが終了しました",
    trial_expired_msg: "SUCOを引き続きご利用いただくにはサブスクリプションが必要です",
    cancel_subscription: "サブスクリプションをキャンセル",
    cancel_confirm: "よろしいですか？お支払い期間終了後にアクセスできなくなります",
    subscription_cancelled: "サブスクリプションが正常にキャンセルされました",
    go_dashboard: "ダッシュボードへ",
    payment_error: "お支払いエラー",
    payment_confirm_error: "お支払いを確認できませんでした",
    try_again: "再試行",
    your_name: "お名前",
    email_placeholder: "email@example.com",
    phone_placeholder: "+81 90 0000 0000",
    error_payment: "支払い開始エラー",
    business_not_found: "ビジネスが見つかりません",
    back_home: "ホームに戻る",
    loading: "読み込み中...",
    error_loading: "データの読み込みエラー",
    invalid_credentials: "認証情報が無効です",
    error_registering: "登録エラー",
    error_sending: "送信エラー",
    status_updated: "ステータスが更新されました",
    tab_profile: "マイプロフィール",
    profile_title: "プロフィール編集",
    profile_subtitle: "ビジネス情報を更新",
    email_cc: "CCメール（通知）",
    email_cc_hint: "このメールにも苦情や提案の通知が届きます",
    change_logo: "ロゴを変更",
    save_changes: "変更を保存",
    support: "サポート",
    download_email_template: "営業メールをダウンロード (Word)",
    saving: "保存中...",
    profile_updated: "プロフィールが更新されました",
    error_updating: "プロフィールの更新エラー",
    current_logo: "現在のロゴ",
    no_logo: "カスタムロゴなし",
    tab_analytics: "アナリティクス",
    analytics_title: "トレンド分析",
    analytics_subtitle: "ビジネスのパフォーマンスを可視化",
    period_7d: "7日間",
    period_30d: "30日間",
    period_90d: "90日間",
    trend_chart_title: "日別の苦情と提案",
    status_chart_title: "ステータス分布",
    total_in_period: "期間合計",
    no_data: "選択した期間のデータなし",
    complaints_label: "苦情",
    suggestions_label: "提案",
    remove: "削除",
    or: "または",
    back: "戻る",
    anonymous: "匿名",

    // Landing Page
    lp_nav_how: "使い方",
    lp_nav_pricing: "料金",
    lp_nav_download: "アプリをダウンロード",
    lp_nav_login: "ログイン",
    lp_nav_cta: "無料で試す",
    lp_hero_title: "Googleの悪いレビューを防ぐ",
    lp_hero_highlight: "起きる前に",
    lp_hero_desc: "シンプルなQRコードでお客様の苦情をお店で直接キャッチ。ネットではなく、あなたに直接伝えてもらえます。",
    lp_hero_cta: "無料で始める",
    lp_hero_how: "仕組みを見る",
    lp_hero_badge: "プライベートに苦情を受信",
    lp_problem_label: "問題",
    lp_problem_title: "不満なお客様はあなたに苦情を言いません...",
    lp_problem_stat_text: "の不満なお客様は直接苦情を言いません。ただ戻ってこなくなり、Googleに悪いレビューを残します。",
    lp_problem_card1_title: "静かに去るお客様",
    lp_problem_card1_desc: "何が不満だったか教えてくれません。ただ戻ってこなくなり、理由は分かりません。",
    lp_problem_card2_title: "公開される悪いレビュー",
    lp_problem_card2_desc: "あなたに言う代わりに、Googleに投稿して誰でも見られるようにします。",
    lp_problem_card3_title: "評判の低下",
    lp_problem_card3_desc: "悪いレビューは新しい潜在的なお客様をビジネスから遠ざけます。",
    lp_solution_label: "解決策",
    lp_solution_title: "SUCOはこんなに簡単",
    lp_solution_subtitle: "3ステップで、怒ったお客様をリピーターに変える",
    lp_step1_title: "お客様がQRをスキャン",
    lp_step1_desc: "テーブル、カウンター、レシートにQRコードを置くだけ。アプリ不要。",
    lp_step2_title: "プライベートにフィードバック",
    lp_step2_desc: "数秒であなたに直接伝えられます。聞いてもらえた、大切にされたと感じます。",
    lp_step3_title: "即座にアラートを受信",
    lp_step3_desc: "すぐにメールが届きます。素早く対応してお客様を取り戻せます。",
    lp_benefits_label: "メリット",
    lp_benefits_title: "ビジネスを守るために必要なすべて",
    lp_benefit1_title: "悪いレビューを防止",
    lp_benefit1_desc: "苦情はGoogleマップやSNSに届く前にあなたに届きます。",
    lp_benefit2_title: "お客様を取り戻す",
    lp_benefit2_desc: "問題に素早く対応し、悪い体験を忠誠に変えます。",
    lp_benefit3_title: "サービスを改善",
    lp_benefit3_desc: "お客様からの直接的なフィードバックで継続的に改善。",
    lp_benefit4_title: "簡単、数分で開始",
    lp_benefit4_desc: "インストール不要。登録してQRを印刷するだけ。",
    lp_benefit5_title: "9言語対応",
    lp_benefit5_desc: "お客様は好みの言語でフィードバックを残せます。",
    lp_benefit6_title: "ロゴ入りQR",
    lp_benefit6_desc: "ビジネスのロゴでQRコードをカスタマイズ。",
    lp_new: "新機能",
    lp_wifi_title: "お客様用WiFi QR",
    lp_wifi_desc: "お客様がWiFiに簡単に接続できるQRコードを生成。オプション機能、ビジネスロゴ付き。",
    lp_pricing_label: "料金",
    lp_pricing_title: "シンプルで透明",
    lp_pricing_subtitle: "7日間無料。契約なし、いつでもキャンセル。",
    lp_pricing_business: "あなたのビジネスに",
    lp_pricing_monthly: "月額プラン",
    lp_pricing_yearly: "年間プラン",
    lp_pricing_save: "29%節約",
    lp_pricing_f1: "QR無制限",
    lp_pricing_f2: "リアルタイムアラート",
    lp_pricing_f3: "分析ダッシュボード",
    lp_pricing_f4: "9言語",
    lp_pricing_f5: "メールサポート",
    lp_pricing_yf1: "月額プランのすべて",
    lp_pricing_yf2: "年間$45.88節約",
    lp_pricing_yf3: "優先サポート",
    lp_pricing_yf4: "カスタムロゴQR",
    lp_pricing_yf5: "PDF・DOCXポスター",
    lp_pricing_enterprise_label: "多店舗ビジネス向け",
    lp_pricing_enterprise_badge: "多店舗",
    lp_pricing_enterprise: "エンタープライズプラン",
    lp_pricing_enterprise_extra: "+ $5.99/月 追加店舗ごと",
    lp_pricing_ef1: "1店舗含む",
    lp_pricing_ef2: "一元管理ダッシュボード",
    lp_pricing_ef3: "店舗ごとの独立メール",
    lp_pricing_ef4: "店舗ごとの独自QR",
    lp_pricing_ef5: "比較分析",
    lp_pricing_ef6: "優先サポート",
    lp_pricing_example: "例：17店舗 = $125.83/月 または $1,243/年",
    lp_pricing_contact: "営業に連絡",
    lp_pricing_trial: "全プラン7日間無料トライアル付き",
    lp_trust_title: "評判を大切にするビジネスに最適",
    lp_trust_desc: "SUCOは顧客体験を重視するビジネスのために設計されています。",
    lp_trust_tags: "レストラン,カフェ,美容室,自動車修理,動物病院,クリニック,ジム,ホテル",
    lp_download_title: "デバイスにSUCOをダウンロード",
    lp_download_desc: "SUCOをアプリとしてインストール。ストア不要。",
    lp_download_btn: "SUCOをインストール",
    lp_download_desktop: "PC (Chrome)",
    lp_download_android: "Android (Chrome)",
    lp_download_ios: "iPhone / iPad (Safari)",
    lp_download_d1: "ChromeでSucomx.comを開く",
    lp_download_d2: "アドレスバーのインストールアイコンをクリック",
    lp_download_d3: "「インストール」を確認",
    lp_download_a1: "Chromeでsucomx.comを開く",
    lp_download_a2: "右上のメニュー（3点）をタップ",
    lp_download_a3: "「アプリをインストール」を選択",
    lp_download_i1: "Safariでsucomx.comを開く",
    lp_download_i2: "共有をタップ",
    lp_download_i3: "「ホーム画面に追加」を選択",
    lp_cta_title: "今日から始めて、理由も分からず客を失うのを止めましょう",
    lp_cta_desc: "2分で登録。クレジットカード不要。",
    lp_cta_btn: "今すぐ始める",
    lp_footer: "QRフィードバックシステム。全著作権所有。"
  },
  
  ar: {
    landing_subtitle: "صوتك مهم.",
    landing_description: "شارك تجاربك وحسّن الخدمة.",
    btn_get_started: "ابدأ",
    btn_have_account: "لدي حساب",
    register_title: "سجل عملك",
    register_subtitle: "أنشئ حسابك واحصل على رمز QR مخصص",
    business_name: "اسم العمل",
    email: "البريد الإلكتروني",
    phone: "الهاتف (اختياري)",
    password: "كلمة المرور",
    poster_language: "لغة الملصق",
    your_logo: "شعارك (اختياري)",
    upload_file: "رفع ملف",
    logo_url: "رابط الشعار",
    logo_hint: "JPG أو PNG أو WEBP (الحد الأقصى 5 ميجابايت). اتركه فارغاً لاستخدام شعار SUCO",
    btn_start_trial: "ابدأ تجربة مجانية لمدة 7 أيام",
    registering: "جاري التسجيل...",
    register_success: "تم تسجيل العمل! لديك 7 أيام تجربة مجانية",
    login_title: "تسجيل الدخول",
    btn_login: "دخول",
    logging_in: "جاري الدخول...",
    no_account: "ليس لديك حساب؟",
    sign_up: "سجل",
    welcome_back: "مرحباً بعودتك!",
    dashboard_subtitle: "لوحة الإدارة",
    tab_overview: "نظرة عامة",
    tab_complaints: "الشكاوى والاقتراحات",
    tab_qr: "رمز QR الخاص بي",
    btn_logout: "خروج",
    free_trial: "تجربة مجانية",
    stat_total: "المجموع",
    stat_pending: "معلق",
    stat_resolved: "تم الحل",
    stat_complaints: "شكاوى",
    stat_suggestions: "اقتراحات",
    no_messages: "لا توجد رسائل بعد",
    share_qr: "شارك رمز QR للحصول على ملاحظات",
    complaint: "شكوى",
    suggestion: "اقتراح",
    change_status: "تغيير الحالة",
    status_pending: "معلق",
    status_in_progress: "قيد التنفيذ",
    status_resolved: "تم الحل",
    status_closed: "مغلق",
    qr_title: "رمز QR المخصص الخاص بك",
    qr_subtitle: "شاركه مع عملائك للحصول على ملاحظات",
    public_url: "الرابط العام:",
    download_qr: "تحميل QR",
    download_pdf: "تحميل PDF",
    download_docx: "تحميل DOCX",
    wifi_qr_title: "رمز WiFi QR",
    wifi_qr_subtitle: "أنشئ رمز QR ليتصل عملاؤك بشبكة WiFi الخاصة بك",
    wifi_network_name: "اسم الشبكة",
    wifi_password: "كلمة المرور",
    wifi_password_placeholder: "اتركه فارغاً إذا لم يكن هناك كلمة مرور",
    wifi_security: "نوع الأمان",
    wifi_no_password: "بدون كلمة مرور",
    wifi_generate_btn: "إنشاء رمز WiFi QR",
    wifi_qr_generated: "تم إنشاء رمز WiFi QR بنجاح",
    wifi_ssid_required: "اسم الشبكة مطلوب",
    wifi_download_qr: "تحميل رمز WiFi QR",
    tab_branches: "الفروع",
    branches_title: "WiFi لكل فرع",
    branches_subtitle: "أنشئ رمز WiFi QR مستقل لكل فرع من فروعك",
    branches_no_branches: "لا توجد فروع مسجلة بعد. أضفها من حسابك المؤسسي.",
    branch_label: "فرع",
    branch_wifi_for: "WiFi الفرع",
    regenerate_qr: "إعادة إنشاء QR",
    qr_regenerated: "تم إعادة إنشاء QR والملصقات بنجاح",
    feedback_question: "ما هي شكواك أو اقتراحك؟",
    category: "الفئة",
    describe_problem: "صف المشكلة أو اقتراحك",
    tell_us: "أخبرنا عن تجربتك...",
    name_optional: "الاسم (اختياري)",
    email_optional: "البريد الإلكتروني (اختياري)",
    phone_optional: "الهاتف (اختياري)",
    btn_send: "إرسال",
    btn_clear: "مسح",
    sending: "جاري الإرسال...",
    thank_you: "شكراً!",
    message_sent: "تم إرسال رسالتك بنجاح.",
    send_another: "إرسال آخر",
    powered_by: "مدعوم من SUCO",
    choose_plan: "اختر خطتك",
    plan_subtitle: "استمتع بـ 7 أيام مجانية، ثم اختر الخطة المناسبة",
    monthly: "الخطة الشهرية",
    yearly: "الخطة السنوية",
    savings: "توفير",
    btn_subscribe: "اشترك",
    processing: "جاري المعالجة...",
    per_year: "/سنة",
    per_month: "/شهر",
    loading_plans: "جاري تحميل الخطط...",
    verifying_payment: "جاري التحقق من الدفع...",
    wait_confirmation: "يرجى الانتظار بينما نؤكد دفعتك",
    payment_success: "تم الدفع بنجاح!",
    subscription_active: "اشتراكك نشط",
    trial_banner: "تجربة مجانية: متبقي {days} أيام",
    trial_banner_last_day: "تجربة مجانية: اليوم الأخير",
    trial_expired: "انتهت تجربتك المجانية",
    trial_expired_msg: "اشترك للاستمرار في استخدام SUCO",
    cancel_subscription: "إلغاء الاشتراك",
    cancel_confirm: "هل أنت متأكد؟ ستفقد الوصول في نهاية فترة الدفع",
    subscription_cancelled: "تم إلغاء الاشتراك بنجاح",
    go_dashboard: "الذهاب للوحة التحكم",
    payment_error: "خطأ في الدفع",
    payment_confirm_error: "لم نتمكن من تأكيد دفعتك",
    try_again: "حاول مرة أخرى",
    your_name: "اسمك",
    email_placeholder: "email@example.com",
    phone_placeholder: "+966 50 000 0000",
    error_payment: "خطأ في بدء الدفع",
    business_not_found: "العمل غير موجود",
    back_home: "العودة للرئيسية",
    loading: "جاري التحميل...",
    error_loading: "خطأ في تحميل البيانات",
    invalid_credentials: "بيانات الاعتماد غير صالحة",
    error_registering: "خطأ في التسجيل",
    error_sending: "خطأ في الإرسال",
    status_updated: "تم تحديث الحالة",
    tab_profile: "ملفي الشخصي",
    profile_title: "تعديل الملف الشخصي",
    profile_subtitle: "تحديث معلومات عملك",
    email_cc: "البريد الإلكتروني CC (الإشعارات)",
    email_cc_hint: "سيتلقى هذا البريد أيضاً إشعارات الشكاوى والاقتراحات",
    change_logo: "تغيير الشعار",
    save_changes: "حفظ التغييرات",
    support: "الدعم",
    download_email_template: "تحميل بريد المبيعات (Word)",
    saving: "جاري الحفظ...",
    profile_updated: "تم تحديث الملف الشخصي بنجاح",
    error_updating: "خطأ في تحديث الملف الشخصي",
    current_logo: "الشعار الحالي",
    no_logo: "بدون شعار مخصص",
    tab_analytics: "التحليلات",
    analytics_title: "تحليل الاتجاهات",
    analytics_subtitle: "تصور أداء عملك",
    period_7d: "7 أيام",
    period_30d: "30 يوم",
    period_90d: "90 يوم",
    trend_chart_title: "الشكاوى والاقتراحات يومياً",
    status_chart_title: "التوزيع حسب الحالة",
    total_in_period: "الإجمالي في الفترة",
    no_data: "لا توجد بيانات للفترة المحددة",
    complaints_label: "شكاوى",
    suggestions_label: "اقتراحات",
    remove: "إزالة",
    or: "أو",
    back: "رجوع",
    anonymous: "مجهول",

    // Landing Page
    lp_nav_how: "كيف يعمل",
    lp_nav_pricing: "الأسعار",
    lp_nav_download: "تحميل التطبيق",
    lp_nav_login: "تسجيل الدخول",
    lp_nav_cta: "جرب مجانا",
    lp_hero_title: "امنع التقييمات السلبية على Google",
    lp_hero_highlight: "قبل أن تحدث",
    lp_hero_desc: "التقط شكاوى عملائك مباشرة في عملك من خلال رمز QR بسيط. يتحدثون إليك، وليس على الإنترنت.",
    lp_hero_cta: "ابدأ مجانا",
    lp_hero_how: "شاهد كيف يعمل",
    lp_hero_badge: "شكوى مستلمة بخصوصية",
    lp_problem_label: "المشكلة",
    lp_problem_title: "عملاؤك غير الراضين لا يشتكون لك...",
    lp_problem_stat_text: "من العملاء غير الراضين لا يشتكون مباشرة أبدا. ببساطة لا يعودون ويتركون تقييما سلبيا على Google.",
    lp_problem_card1_title: "عملاء يغادرون بصمت",
    lp_problem_card1_desc: "لا يخبرونك بما أزعجهم. فقط لا يعودون ولا تعرف السبب أبدا.",
    lp_problem_card2_title: "تقييمات سلبية عامة",
    lp_problem_card2_desc: "بدلا من إخبارك، ينشرون على Google ليراها الجميع.",
    lp_problem_card3_title: "خسارة السمعة",
    lp_problem_card3_desc: "كل تقييم سلبي يبعد عملاء جدد محتملين عن عملك.",
    lp_solution_label: "الحل",
    lp_solution_title: "هكذا ببساطة يعمل SUCO",
    lp_solution_subtitle: "في 3 خطوات، حوّل عميلا غاضبا إلى عميل يعود",
    lp_step1_title: "العميل يمسح رمز QR",
    lp_step1_desc: "ضع رمز QR على الطاولات أو الكاونتر أو الإيصالات. لا حاجة لتثبيت شيء.",
    lp_step2_title: "يترك ملاحظاته بخصوصية",
    lp_step2_desc: "يتحدث إليك مباشرة في ثوان. يشعر بأنه مسموع ومقدر.",
    lp_step3_title: "تتلقى التنبيه فورا",
    lp_step3_desc: "تصلك رسالة بريد فورية. يمكنك التصرف بسرعة واستعادة العميل.",
    lp_benefits_label: "المزايا",
    lp_benefits_title: "كل ما تحتاجه لحماية عملك",
    lp_benefit1_title: "امنع التقييمات السلبية",
    lp_benefit1_desc: "الشكاوى تصلك قبل أن تصل إلى خرائط Google أو وسائل التواصل.",
    lp_benefit2_title: "استعد العملاء",
    lp_benefit2_desc: "تصرف بسرعة وحوّل تجربة سيئة إلى ولاء.",
    lp_benefit3_title: "حسّن خدمتك",
    lp_benefit3_desc: "احصل على ملاحظات حقيقية ومباشرة من عملائك للتحسين المستمر.",
    lp_benefit4_title: "سهل الاستخدام، يعمل في دقائق",
    lp_benefit4_desc: "بدون تثبيت. سجل واطبع رمز QR وانطلق.",
    lp_benefit5_title: "9 لغات مدعومة",
    lp_benefit5_desc: "يمكن لعملائك ترك ملاحظاتهم بلغتهم المفضلة.",
    lp_benefit6_title: "QR بشعارك",
    lp_benefit6_desc: "خصص رمز QR بشعار عملك لمزيد من الثقة.",
    lp_new: "جديد",
    lp_wifi_title: "رمز WiFi QR للعملاء",
    lp_wifi_desc: "أنشئ رمز QR ليتصل عملاؤك بسهولة بشبكة WiFi. اختياري وبشعار عملك.",
    lp_pricing_label: "الأسعار",
    lp_pricing_title: "بسيط وشفاف",
    lp_pricing_subtitle: "ابدأ بـ 7 أيام مجانية. بدون عقود، ألغ في أي وقت.",
    lp_pricing_business: "لعملك",
    lp_pricing_monthly: "الخطة الشهرية",
    lp_pricing_yearly: "الخطة السنوية",
    lp_pricing_save: "وفر 29%",
    lp_pricing_f1: "رموز QR غير محدودة",
    lp_pricing_f2: "تنبيهات فورية",
    lp_pricing_f3: "لوحة تحليلات",
    lp_pricing_f4: "9 لغات",
    lp_pricing_f5: "دعم بالبريد",
    lp_pricing_yf1: "كل ما في الخطة الشهرية",
    lp_pricing_yf2: "وفر $45.88 سنويا",
    lp_pricing_yf3: "دعم ذو أولوية",
    lp_pricing_yf4: "QR بشعار مخصص",
    lp_pricing_yf5: "ملصقات PDF و DOCX",
    lp_pricing_enterprise_label: "للأعمال متعددة الفروع",
    lp_pricing_enterprise_badge: "متعدد الفروع",
    lp_pricing_enterprise: "خطة المؤسسات",
    lp_pricing_enterprise_extra: "+ $5.99/شهر لكل فرع إضافي",
    lp_pricing_ef1: "فرع واحد مشمول",
    lp_pricing_ef2: "لوحة تحكم مركزية",
    lp_pricing_ef3: "بريد مستقل لكل فرع",
    lp_pricing_ef4: "QR فريد لكل فرع",
    lp_pricing_ef5: "تحليلات مقارنة",
    lp_pricing_ef6: "دعم ذو أولوية",
    lp_pricing_example: "مثال: 17 فرع = $125.83/شهر أو $1,243/سنة",
    lp_pricing_contact: "اتصل بالمبيعات",
    lp_pricing_trial: "تجربة مجانية 7 أيام مع جميع الخطط",
    lp_trust_title: "مثالي للأعمال التي تهتم بسمعتها",
    lp_trust_desc: "SUCO مصمم لأي عمل تهم فيه تجربة العميل.",
    lp_trust_tags: "مطاعم,مقاهي,صالونات,ورش سيارات,عيادات بيطرية,عيادات طبية,صالات رياضية,فنادق",
    lp_download_title: "حمل SUCO على جهازك",
    lp_download_desc: "ثبت SUCO كتطبيق. بدون متجر تطبيقات.",
    lp_download_btn: "تثبيت SUCO",
    lp_download_desktop: "على الكمبيوتر (Chrome)",
    lp_download_android: "على أندرويد (Chrome)",
    lp_download_ios: "على iPhone / iPad (Safari)",
    lp_download_d1: "افتح sucomx.com في Google Chrome",
    lp_download_d2: "انقر على أيقونة التثبيت في شريط العنوان",
    lp_download_d3: "أكد بالنقر على تثبيت",
    lp_download_a1: "افتح sucomx.com في Chrome",
    lp_download_a2: "انقر على القائمة (ثلاث نقاط) أعلى اليمين",
    lp_download_a3: "اختر تثبيت التطبيق",
    lp_download_i1: "افتح sucomx.com في Safari",
    lp_download_i2: "انقر على مشاركة",
    lp_download_i3: "اختر إضافة إلى الشاشة الرئيسية",
    lp_cta_title: "ابدأ اليوم وتوقف عن خسارة العملاء دون معرفة السبب",
    lp_cta_desc: "سجل في أقل من دقيقتين. لا حاجة لبطاقة ائتمان.",
    lp_cta_btn: "ابدأ الآن",
    lp_footer: "نظام ملاحظات QR. جميع الحقوق محفوظة."
  },
  
  de: {
    landing_subtitle: "Ihre Stimme zählt.",
    landing_description: "Teilen Sie Ihre Erfahrungen und verbessern Sie den Service.",
    btn_get_started: "Loslegen",
    btn_have_account: "Ich habe ein Konto",
    register_title: "Registrieren Sie Ihr Unternehmen",
    register_subtitle: "Erstellen Sie Ihr Konto und erhalten Sie Ihren personalisierten QR",
    business_name: "Unternehmensname",
    email: "E-Mail",
    phone: "Telefon (optional)",
    password: "Passwort",
    poster_language: "Postersprache",
    your_logo: "Ihr Logo (optional)",
    upload_file: "Datei hochladen",
    logo_url: "Logo-URL",
    logo_hint: "JPG, PNG oder WEBP (max. 5MB). Leer lassen für SUCO-Logo",
    btn_start_trial: "7-tägige kostenlose Testversion starten",
    registering: "Registrierung...",
    register_success: "Unternehmen registriert! Sie haben 7 Tage kostenlose Testversion",
    login_title: "Anmelden",
    btn_login: "Anmelden",
    logging_in: "Anmeldung...",
    no_account: "Kein Konto?",
    sign_up: "Registrieren",
    welcome_back: "Willkommen zurück!",
    dashboard_subtitle: "Admin-Panel",
    tab_overview: "Übersicht",
    tab_complaints: "Beschwerden & Vorschläge",
    tab_qr: "Mein QR",
    btn_logout: "Abmelden",
    free_trial: "Kostenlose Testversion",
    stat_total: "Gesamt",
    stat_pending: "Ausstehend",
    stat_resolved: "Gelöst",
    stat_complaints: "Beschwerden",
    stat_suggestions: "Vorschläge",
    no_messages: "Noch keine Nachrichten",
    share_qr: "Teilen Sie Ihren QR, um Feedback zu erhalten",
    complaint: "Beschwerde",
    suggestion: "Vorschlag",
    change_status: "Status ändern",
    status_pending: "Ausstehend",
    status_in_progress: "In Bearbeitung",
    status_resolved: "Gelöst",
    status_closed: "Geschlossen",
    qr_title: "Ihr personalisierter QR-Code",
    qr_subtitle: "Teilen Sie ihn mit Ihren Kunden, um Feedback zu erhalten",
    public_url: "Öffentliche URL:",
    download_qr: "QR herunterladen",
    download_pdf: "PDF herunterladen",
    download_docx: "DOCX herunterladen",
    wifi_qr_title: "WiFi QR-Code",
    wifi_qr_subtitle: "Erstellen Sie einen QR-Code, damit Ihre Kunden sich mit Ihrem WLAN verbinden können",
    wifi_network_name: "Netzwerkname",
    wifi_password: "Passwort",
    wifi_password_placeholder: "Leer lassen, wenn kein Passwort",
    wifi_security: "Sicherheitstyp",
    wifi_no_password: "Kein Passwort",
    wifi_generate_btn: "WiFi QR generieren",
    wifi_qr_generated: "WiFi QR-Code erfolgreich generiert",
    wifi_ssid_required: "Netzwerkname ist erforderlich",
    wifi_download_qr: "WiFi QR herunterladen",
    tab_branches: "Filialen",
    branches_title: "WLAN pro Filiale",
    branches_subtitle: "Erstellen Sie einen eigenen WLAN-QR-Code für jede Ihrer Filialen",
    branches_no_branches: "Noch keine Filialen registriert. Fügen Sie sie über Ihr Unternehmenskonto hinzu.",
    branch_label: "Filiale",
    branch_wifi_for: "WLAN der Filiale",
    regenerate_qr: "QR neu generieren",
    qr_regenerated: "QR und Poster erfolgreich neu generiert",
    feedback_question: "Was ist Ihre Beschwerde oder Ihr Vorschlag?",
    category: "Kategorie",
    describe_problem: "Beschreiben Sie das Problem oder Ihren Vorschlag",
    tell_us: "Erzählen Sie uns von Ihrer Erfahrung...",
    name_optional: "Name (optional)",
    email_optional: "E-Mail (optional)",
    phone_optional: "Telefon (optional)",
    btn_send: "Senden",
    btn_clear: "Löschen",
    sending: "Senden...",
    thank_you: "Danke!",
    message_sent: "Ihre Nachricht wurde erfolgreich gesendet.",
    send_another: "Weitere senden",
    powered_by: "Powered by SUCO",
    choose_plan: "Wählen Sie Ihren Plan",
    plan_subtitle: "Genießen Sie 7 kostenlose Tage, dann wählen Sie den besten Plan",
    monthly: "Monatsplan",
    yearly: "Jahresplan",
    savings: "Ersparnis",
    btn_subscribe: "Abonnieren",
    processing: "Verarbeitung...",
    per_year: "/Jahr",
    per_month: "/Monat",
    loading_plans: "Pläne werden geladen...",
    verifying_payment: "Zahlung wird überprüft...",
    wait_confirmation: "Bitte warten Sie, während wir Ihre Zahlung bestätigen",
    payment_success: "Zahlung erfolgreich!",
    subscription_active: "Ihr Abonnement ist aktiv",
    trial_banner: "Kostenlose Testversion: noch {days} Tage",
    trial_banner_last_day: "Kostenlose Testversion: letzter Tag",
    trial_expired: "Ihre kostenlose Testversion ist abgelaufen",
    trial_expired_msg: "Abonnieren Sie, um SUCO weiter zu nutzen",
    cancel_subscription: "Abonnement kündigen",
    cancel_confirm: "Sind Sie sicher? Sie verlieren den Zugang am Ende Ihres Abrechnungszeitraums",
    subscription_cancelled: "Abonnement erfolgreich gekündigt",
    go_dashboard: "Zum Dashboard",
    payment_error: "Zahlungsfehler",
    payment_confirm_error: "Wir konnten Ihre Zahlung nicht bestätigen",
    try_again: "Erneut versuchen",
    your_name: "Ihr Name",
    email_placeholder: "email@beispiel.de",
    phone_placeholder: "+49 170 000 0000",
    error_payment: "Fehler beim Starten der Zahlung",
    business_not_found: "Unternehmen nicht gefunden",
    back_home: "Zurück zur Startseite",
    loading: "Laden...",
    error_loading: "Fehler beim Laden der Daten",
    invalid_credentials: "Ungültige Anmeldedaten",
    error_registering: "Fehler bei der Registrierung",
    error_sending: "Fehler beim Senden",
    status_updated: "Status aktualisiert",
    tab_profile: "Mein Profil",
    profile_title: "Profil bearbeiten",
    profile_subtitle: "Aktualisieren Sie Ihre Unternehmensinformationen",
    email_cc: "CC-E-Mail (Benachrichtigungen)",
    email_cc_hint: "Diese E-Mail erhält auch Benachrichtigungen über Beschwerden und Vorschläge",
    change_logo: "Logo ändern",
    save_changes: "Änderungen speichern",
    support: "Support",
    download_email_template: "Verkaufs-E-Mail herunterladen (Word)",
    saving: "Speichern...",
    profile_updated: "Profil erfolgreich aktualisiert",
    error_updating: "Fehler beim Aktualisieren des Profils",
    current_logo: "Aktuelles Logo",
    no_logo: "Kein benutzerdefiniertes Logo",
    tab_analytics: "Analytik",
    analytics_title: "Trendanalyse",
    analytics_subtitle: "Visualisieren Sie die Leistung Ihres Unternehmens",
    period_7d: "7 Tage",
    period_30d: "30 Tage",
    period_90d: "90 Tage",
    trend_chart_title: "Beschwerden und Vorschläge pro Tag",
    status_chart_title: "Verteilung nach Status",
    total_in_period: "Gesamt im Zeitraum",
    no_data: "Keine Daten für den ausgewählten Zeitraum",
    complaints_label: "Beschwerden",
    suggestions_label: "Vorschläge",
    remove: "Entfernen",
    or: "oder",
    back: "Zurück",
    anonymous: "Anonym",

    // Landing Page
    lp_nav_how: "So funktioniert es",
    lp_nav_pricing: "Preise",
    lp_nav_download: "App herunterladen",
    lp_nav_login: "Anmelden",
    lp_nav_cta: "Gratis testen",
    lp_hero_title: "Verhindern Sie schlechte Google-Bewertungen",
    lp_hero_highlight: "bevor sie passieren",
    lp_hero_desc: "Erfassen Sie Kundenbeschwerden direkt in Ihrem Geschaeft mit einem einfachen QR-Code. Kunden beschweren sich bei Ihnen, nicht im Internet.",
    lp_hero_cta: "Gratis starten",
    lp_hero_how: "So funktioniert es",
    lp_hero_badge: "Beschwerde privat erhalten",
    lp_problem_label: "Das Problem",
    lp_problem_title: "Unzufriedene Kunden beschweren sich nicht bei Ihnen...",
    lp_problem_stat_text: "der unzufriedenen Kunden beschweren sich nie direkt. Sie kommen einfach nicht wieder und hinterlassen eine schlechte Bewertung auf Google.",
    lp_problem_card1_title: "Kunden, die leise gehen",
    lp_problem_card1_desc: "Sie sagen nicht, was sie gestoert hat. Sie kommen einfach nicht wieder.",
    lp_problem_card2_title: "Oeffentliche negative Bewertungen",
    lp_problem_card2_desc: "Statt es Ihnen zu sagen, posten sie es auf Google fuer alle sichtbar.",
    lp_problem_card3_title: "Reputationsverlust",
    lp_problem_card3_desc: "Jede schlechte Bewertung vertreibt potenzielle neue Kunden.",
    lp_solution_label: "Die Loesung",
    lp_solution_title: "So einfach funktioniert SUCO",
    lp_solution_subtitle: "In 3 Schritten verwandeln Sie einen veraergerten Kunden in einen Stammkunden",
    lp_step1_title: "Kunde scannt den QR-Code",
    lp_step1_desc: "Platzieren Sie den QR-Code auf Tischen, Theke oder Quittungen. Keine App noetig.",
    lp_step2_title: "Gibt privat Feedback",
    lp_step2_desc: "Teilt Ihnen in Sekunden direkt mit. Fuehlt sich gehoert und geschaetzt.",
    lp_step3_title: "Sie erhalten sofort eine Benachrichtigung",
    lp_step3_desc: "Sie bekommen sofort eine E-Mail. Schnell handeln und Kunden zurueckgewinnen.",
    lp_benefits_label: "Vorteile",
    lp_benefits_title: "Alles was Sie zum Schutz Ihres Geschaefts brauchen",
    lp_benefit1_title: "Schlechte Bewertungen verhindern",
    lp_benefit1_desc: "Beschwerden erreichen Sie, bevor sie Google Maps oder Social Media erreichen.",
    lp_benefit2_title: "Kunden zurueckgewinnen",
    lp_benefit2_desc: "Schnell auf Probleme reagieren und schlechte Erfahrungen in Treue verwandeln.",
    lp_benefit3_title: "Service verbessern",
    lp_benefit3_desc: "Echtes, direktes Feedback von Kunden fuer kontinuierliche Verbesserung.",
    lp_benefit4_title: "Einfach, funktioniert in Minuten",
    lp_benefit4_desc: "Keine Installation. Registrieren, QR drucken, fertig.",
    lp_benefit5_title: "9 Sprachen inklusive",
    lp_benefit5_desc: "Ihre Kunden koennen Feedback in ihrer bevorzugten Sprache hinterlassen.",
    lp_benefit6_title: "QR mit Ihrem Logo",
    lp_benefit6_desc: "QR-Code mit Ihrem Geschaeftslogo fuer mehr Vertrauen.",
    lp_new: "Neu",
    lp_wifi_title: "WiFi QR für Kunden",
    lp_wifi_desc: "Erstellen Sie einen QR-Code, damit Ihre Kunden sich einfach mit Ihrem WLAN verbinden. Optional und mit Ihrem Logo.",
    lp_pricing_label: "Preise",
    lp_pricing_title: "Einfach und transparent",
    lp_pricing_subtitle: "Starten Sie mit 7 Gratistagen. Keine Vertraege, jederzeit kuendbar.",
    lp_pricing_business: "Fuer Ihr Geschaeft",
    lp_pricing_monthly: "Monatsplan",
    lp_pricing_yearly: "Jahresplan",
    lp_pricing_save: "29% sparen",
    lp_pricing_f1: "Unbegrenzte QR-Codes",
    lp_pricing_f2: "Echtzeit-Benachrichtigungen",
    lp_pricing_f3: "Analyse-Dashboard",
    lp_pricing_f4: "9 Sprachen",
    lp_pricing_f5: "E-Mail-Support",
    lp_pricing_yf1: "Alles im Monatsplan",
    lp_pricing_yf2: "$45.88 pro Jahr sparen",
    lp_pricing_yf3: "Prioritaets-Support",
    lp_pricing_yf4: "QR mit eigenem Logo",
    lp_pricing_yf5: "PDF- und DOCX-Poster",
    lp_pricing_enterprise_label: "Fuer Unternehmen mit Filialen",
    lp_pricing_enterprise_badge: "Multi-Filiale",
    lp_pricing_enterprise: "Enterprise-Plan",
    lp_pricing_enterprise_extra: "+ $5.99/Monat pro zusaetzliche Filiale",
    lp_pricing_ef1: "1 Filiale inklusive",
    lp_pricing_ef2: "Zentrales Dashboard",
    lp_pricing_ef3: "Unabhaengige E-Mail pro Filiale",
    lp_pricing_ef4: "Eigener QR pro Filiale",
    lp_pricing_ef5: "Vergleichende Analysen",
    lp_pricing_ef6: "Prioritaets-Support",
    lp_pricing_example: "Beispiel: 17 Filialen = $125.83/Mo. oder $1.243/Jahr",
    lp_pricing_contact: "Vertrieb kontaktieren",
    lp_pricing_trial: "7 Tage kostenlos bei allen Plaenen",
    lp_trust_title: "Ideal fuer Unternehmen, die ihren Ruf schuetzen wollen",
    lp_trust_desc: "SUCO ist fuer jedes Unternehmen konzipiert, in dem Kundenerfahrung zaehlt.",
    lp_trust_tags: "Restaurants,Cafes,Friseursalons,Werkstaetten,Tierarztpraxen,Arztpraxen,Fitnessstudios,Hotels",
    lp_download_title: "SUCO auf Ihrem Geraet herunterladen",
    lp_download_desc: "Installieren Sie SUCO als App. Kein App-Store noetig.",
    lp_download_btn: "SUCO installieren",
    lp_download_desktop: "Am Computer (Chrome)",
    lp_download_android: "Auf Android (Chrome)",
    lp_download_ios: "Auf iPhone / iPad (Safari)",
    lp_download_d1: "Oeffnen Sie sucomx.com in Google Chrome",
    lp_download_d2: "Klicken Sie auf das Installationssymbol in der Adressleiste",
    lp_download_d3: "Bestaetigen Sie mit Installieren",
    lp_download_a1: "Oeffnen Sie sucomx.com in Chrome",
    lp_download_a2: "Tippen Sie auf das Menue (drei Punkte) oben rechts",
    lp_download_a3: "Waehlen Sie App installieren",
    lp_download_i1: "Oeffnen Sie sucomx.com in Safari",
    lp_download_i2: "Tippen Sie auf Teilen",
    lp_download_i3: "Waehlen Sie Zum Home-Bildschirm",
    lp_cta_title: "Starten Sie heute und verlieren Sie keine Kunden mehr ohne den Grund zu kennen",
    lp_cta_desc: "Registrieren Sie sich in weniger als 2 Minuten. Keine Kreditkarte erforderlich.",
    lp_cta_btn: "Jetzt starten",
    lp_footer: "QR-Feedback-System. Alle Rechte vorbehalten."
  },
  
  it: {
    landing_subtitle: "La tua voce conta.",
    landing_description: "Condividi le tue esperienze e migliora il servizio.",
    btn_get_started: "Inizia",
    btn_have_account: "Ho già un account",
    register_title: "Registra la tua attività",
    register_subtitle: "Crea il tuo account e ottieni il tuo QR personalizzato",
    business_name: "Nome attività",
    email: "Email",
    phone: "Telefono (opzionale)",
    password: "Password",
    poster_language: "Lingua del poster",
    your_logo: "Il tuo logo (opzionale)",
    upload_file: "Carica file",
    logo_url: "URL del logo",
    logo_hint: "JPG, PNG o WEBP (max 5MB). Lascia vuoto per usare il logo SUCO",
    btn_start_trial: "Inizia prova gratuita di 7 giorni",
    registering: "Registrazione...",
    register_success: "Attività registrata! Hai 7 giorni di prova gratuita",
    login_title: "Accedi",
    btn_login: "Accedi",
    logging_in: "Accesso...",
    no_account: "Non hai un account?",
    sign_up: "Registrati",
    welcome_back: "Bentornato!",
    dashboard_subtitle: "Pannello di amministrazione",
    tab_overview: "Panoramica",
    tab_complaints: "Reclami e Suggerimenti",
    tab_qr: "Il mio QR",
    btn_logout: "Esci",
    free_trial: "Prova gratuita",
    stat_total: "Totale",
    stat_pending: "In sospeso",
    stat_resolved: "Risolti",
    stat_complaints: "Reclami",
    stat_suggestions: "Suggerimenti",
    no_messages: "Nessun messaggio ancora",
    share_qr: "Condividi il tuo QR per ricevere feedback",
    complaint: "Reclamo",
    suggestion: "Suggerimento",
    change_status: "Cambia stato",
    status_pending: "In sospeso",
    status_in_progress: "In corso",
    status_resolved: "Risolto",
    status_closed: "Chiuso",
    qr_title: "Il tuo codice QR personalizzato",
    qr_subtitle: "Condividilo con i tuoi clienti per ricevere feedback",
    public_url: "URL pubblico:",
    download_qr: "Scarica QR",
    download_pdf: "Scarica PDF",
    download_docx: "Scarica DOCX",
    wifi_qr_title: "QR Code WiFi",
    wifi_qr_subtitle: "Genera un codice QR per far connettere i tuoi clienti al tuo WiFi",
    wifi_network_name: "Nome della rete",
    wifi_password: "Password",
    wifi_password_placeholder: "Lascia vuoto se non c'è password",
    wifi_security: "Tipo di sicurezza",
    wifi_no_password: "Senza password",
    wifi_generate_btn: "Genera QR WiFi",
    wifi_qr_generated: "QR WiFi generato con successo",
    wifi_ssid_required: "Il nome della rete è obbligatorio",
    wifi_download_qr: "Scarica QR WiFi",
    tab_branches: "Filiali",
    branches_title: "WiFi per Filiale",
    branches_subtitle: "Genera un QR WiFi indipendente per ciascuna delle tue filiali",
    branches_no_branches: "Nessuna filiale registrata. Aggiungile dal tuo account aziendale.",
    branch_label: "Filiale",
    branch_wifi_for: "WiFi della filiale",
    regenerate_qr: "Rigenera QR",
    qr_regenerated: "QR e poster rigenerati con successo",
    feedback_question: "Qual è il tuo reclamo o suggerimento?",
    category: "Categoria",
    describe_problem: "Descrivi il problema o il tuo suggerimento",
    tell_us: "Raccontaci la tua esperienza...",
    name_optional: "Nome (opzionale)",
    email_optional: "Email (opzionale)",
    phone_optional: "Telefono (opzionale)",
    btn_send: "Invia",
    btn_clear: "Cancella",
    sending: "Invio...",
    thank_you: "Grazie!",
    message_sent: "Il tuo messaggio è stato inviato con successo.",
    send_another: "Invia un altro",
    powered_by: "Powered by SUCO",
    choose_plan: "Scegli il tuo piano",
    plan_subtitle: "Goditi 7 giorni gratuiti, poi scegli il piano migliore per te",
    monthly: "Piano Mensile",
    yearly: "Piano Annuale",
    savings: "di risparmio",
    btn_subscribe: "Abbonati",
    processing: "Elaborazione...",
    per_year: "/anno",
    per_month: "/mese",
    loading_plans: "Caricamento piani...",
    verifying_payment: "Verifica pagamento...",
    wait_confirmation: "Attendi mentre confermiamo il tuo pagamento",
    payment_success: "Pagamento riuscito!",
    subscription_active: "Il tuo abbonamento è attivo",
    trial_banner: "Prova gratuita: {days} giorni rimasti",
    trial_banner_last_day: "Prova gratuita: ultimo giorno",
    trial_expired: "La tua prova gratuita è scaduta",
    trial_expired_msg: "Abbonati per continuare a usare SUCO",
    cancel_subscription: "Annulla abbonamento",
    cancel_confirm: "Sei sicuro? Perderai l'accesso alla fine del periodo di fatturazione",
    subscription_cancelled: "Abbonamento annullato con successo",
    go_dashboard: "Vai alla Dashboard",
    payment_error: "Errore di pagamento",
    payment_confirm_error: "Non siamo riusciti a confermare il tuo pagamento",
    try_again: "Riprova",
    your_name: "Il tuo nome",
    email_placeholder: "email@esempio.com",
    phone_placeholder: "+39 333 000 0000",
    error_payment: "Errore nell'avvio del pagamento",
    business_not_found: "Attività non trovata",
    back_home: "Torna alla home",
    loading: "Caricamento...",
    error_loading: "Errore nel caricamento dei dati",
    invalid_credentials: "Credenziali non valide",
    error_registering: "Errore nella registrazione",
    error_sending: "Errore nell'invio",
    status_updated: "Stato aggiornato",
    tab_profile: "Il mio Profilo",
    profile_title: "Modifica Profilo",
    profile_subtitle: "Aggiorna le informazioni della tua attività",
    email_cc: "Email CC (notifiche)",
    email_cc_hint: "Questa email riceverà anche le notifiche di reclami e suggerimenti",
    change_logo: "Cambia logo",
    save_changes: "Salva modifiche",
    support: "Supporto",
    download_email_template: "Scarica email commerciale (Word)",
    saving: "Salvataggio...",
    profile_updated: "Profilo aggiornato con successo",
    error_updating: "Errore nell'aggiornamento del profilo",
    current_logo: "Logo attuale",
    no_logo: "Nessun logo personalizzato",
    tab_analytics: "Analisi",
    analytics_title: "Analisi delle Tendenze",
    analytics_subtitle: "Visualizza le prestazioni della tua attività",
    period_7d: "7 giorni",
    period_30d: "30 giorni",
    period_90d: "90 giorni",
    trend_chart_title: "Reclami e Suggerimenti al giorno",
    status_chart_title: "Distribuzione per Stato",
    total_in_period: "Totale nel periodo",
    no_data: "Nessun dato per il periodo selezionato",
    complaints_label: "Reclami",
    suggestions_label: "Suggerimenti",
    remove: "Rimuovi",
    or: "o",
    back: "Indietro",
    anonymous: "Anonimo",

    // Landing Page
    lp_nav_how: "Come funziona",
    lp_nav_pricing: "Prezzi",
    lp_nav_download: "Scarica App",
    lp_nav_login: "Accedi",
    lp_nav_cta: "Prova gratis",
    lp_hero_title: "Previeni le recensioni negative su Google",
    lp_hero_highlight: "prima che accadano",
    lp_hero_desc: "Cattura i reclami dei tuoi clienti direttamente nella tua attivita con un semplice codice QR. Si sfogano con te, non su internet.",
    lp_hero_cta: "Inizia gratis",
    lp_hero_how: "Vedi come funziona",
    lp_hero_badge: "Reclamo ricevuto in privato",
    lp_problem_label: "Il problema",
    lp_problem_title: "I tuoi clienti insoddisfatti non si lamentano con te...",
    lp_problem_stat_text: "dei clienti insoddisfatti non si lamenta mai direttamente. Semplicemente non tornano e lasciano una recensione negativa su Google.",
    lp_problem_card1_title: "Clienti che se ne vanno in silenzio",
    lp_problem_card1_desc: "Non ti dicono cosa li ha infastiditi. Semplicemente non tornano e non saprai mai perche.",
    lp_problem_card2_title: "Recensioni negative pubbliche",
    lp_problem_card2_desc: "Invece di dirtelo, lo pubblicano su Google per tutti da vedere.",
    lp_problem_card3_title: "Perdita di reputazione",
    lp_problem_card3_desc: "Ogni cattiva recensione allontana potenziali nuovi clienti dalla tua attivita.",
    lp_solution_label: "La soluzione",
    lp_solution_title: "Ecco come funziona SUCO",
    lp_solution_subtitle: "In 3 passi, trasforma un cliente arrabbiato in uno che torna",
    lp_step1_title: "Il cliente scansiona il QR",
    lp_step1_desc: "Posiziona il QR su tavoli, bancone o ricevute. Nessuna app da installare.",
    lp_step2_title: "Lascia il suo feedback in privato",
    lp_step2_desc: "Si sfoga direttamente con te in pochi secondi. Si sente ascoltato e apprezzato.",
    lp_step3_title: "Ricevi l'avviso immediatamente",
    lp_step3_desc: "Ricevi un'email istantanea. Puoi agire rapidamente e recuperare il cliente.",
    lp_benefits_label: "Vantaggi",
    lp_benefits_title: "Tutto cio di cui hai bisogno per proteggere la tua attivita",
    lp_benefit1_title: "Previeni le cattive recensioni",
    lp_benefit1_desc: "I reclami arrivano a te prima di arrivare su Google Maps o social media.",
    lp_benefit2_title: "Recupera i clienti",
    lp_benefit2_desc: "Agisci rapidamente e trasforma una brutta esperienza in fedelta.",
    lp_benefit3_title: "Migliora il servizio",
    lp_benefit3_desc: "Ricevi feedback reali e diretti per migliorare continuamente.",
    lp_benefit4_title: "Facile da usare, funziona in minuti",
    lp_benefit4_desc: "Nessuna installazione. Registrati, stampa il QR e vai.",
    lp_benefit5_title: "9 lingue incluse",
    lp_benefit5_desc: "I tuoi clienti possono lasciare feedback nella loro lingua preferita.",
    lp_benefit6_title: "QR con il tuo logo",
    lp_benefit6_desc: "Personalizza il QR con il logo della tua attivita per maggiore fiducia.",
    lp_new: "Novità",
    lp_wifi_title: "QR WiFi per i clienti",
    lp_wifi_desc: "Genera un QR code per far connettere i tuoi clienti al WiFi. Opzionale e con il logo della tua attività.",
    lp_pricing_label: "Prezzi",
    lp_pricing_title: "Semplice e trasparente",
    lp_pricing_subtitle: "Inizia con 7 giorni gratis. Senza contratti, annulla quando vuoi.",
    lp_pricing_business: "Per la tua attivita",
    lp_pricing_monthly: "Piano Mensile",
    lp_pricing_yearly: "Piano Annuale",
    lp_pricing_save: "Risparmia 29%",
    lp_pricing_f1: "QR illimitati",
    lp_pricing_f2: "Avvisi in tempo reale",
    lp_pricing_f3: "Dashboard analitico",
    lp_pricing_f4: "9 lingue",
    lp_pricing_f5: "Supporto email",
    lp_pricing_yf1: "Tutto del piano mensile",
    lp_pricing_yf2: "Risparmia $45.88 all'anno",
    lp_pricing_yf3: "Supporto prioritario",
    lp_pricing_yf4: "QR con logo personalizzato",
    lp_pricing_yf5: "Poster PDF e DOCX",
    lp_pricing_enterprise_label: "Per attivita con filiali",
    lp_pricing_enterprise_badge: "Multi-filiale",
    lp_pricing_enterprise: "Piano Enterprise",
    lp_pricing_enterprise_extra: "+ $5.99/mese per filiale aggiuntiva",
    lp_pricing_ef1: "1 filiale inclusa",
    lp_pricing_ef2: "Dashboard centralizzato",
    lp_pricing_ef3: "Email indipendente per filiale",
    lp_pricing_ef4: "QR unico per filiale",
    lp_pricing_ef5: "Analisi comparative",
    lp_pricing_ef6: "Supporto prioritario",
    lp_pricing_example: "Esempio: 17 filiali = $125.83/mese o $1.243/anno",
    lp_pricing_contact: "Contatta le vendite",
    lp_pricing_trial: "7 giorni di prova gratuita inclusi in tutti i piani",
    lp_trust_title: "Ideale per attivita che vogliono proteggere la loro reputazione",
    lp_trust_desc: "SUCO e progettato per qualsiasi attivita dove l'esperienza del cliente conta.",
    lp_trust_tags: "Ristoranti,Caffetterie,Saloni,Officine,Veterinari,Studi medici,Palestre,Hotel",
    lp_download_title: "Scarica SUCO sul tuo dispositivo",
    lp_download_desc: "Installa SUCO come app. Senza app store, senza attese.",
    lp_download_btn: "Installa SUCO",
    lp_download_desktop: "Su computer (Chrome)",
    lp_download_android: "Su Android (Chrome)",
    lp_download_ios: "Su iPhone / iPad (Safari)",
    lp_download_d1: "Apri sucomx.com in Google Chrome",
    lp_download_d2: "Clicca sull'icona di installazione nella barra degli indirizzi",
    lp_download_d3: "Conferma con Installa",
    lp_download_a1: "Apri sucomx.com in Chrome",
    lp_download_a2: "Tocca il menu (tre puntini) in alto a destra",
    lp_download_a3: "Seleziona Installa app",
    lp_download_i1: "Apri sucomx.com in Safari",
    lp_download_i2: "Tocca Condividi",
    lp_download_i3: "Seleziona Aggiungi alla schermata Home",
    lp_cta_title: "Inizia oggi e smetti di perdere clienti senza sapere perche",
    lp_cta_desc: "Registrati in meno di 2 minuti. Nessuna carta di credito richiesta.",
    lp_cta_btn: "Inizia ora",
    lp_footer: "Sistema di feedback QR. Tutti i diritti riservati."
  },
  
  fr: {
    landing_subtitle: "Votre voix compte.",
    landing_description: "Partagez vos expériences et améliorez le service.",
    btn_get_started: "Commencer",
    btn_have_account: "J'ai un compte",
    register_title: "Enregistrez votre entreprise",
    register_subtitle: "Créez votre compte et obtenez votre QR personnalisé",
    business_name: "Nom de l'entreprise",
    email: "Email",
    phone: "Téléphone (optionnel)",
    password: "Mot de passe",
    poster_language: "Langue de l'affiche",
    your_logo: "Votre logo (optionnel)",
    upload_file: "Télécharger fichier",
    logo_url: "URL du logo",
    logo_hint: "JPG, PNG ou WEBP (max 5Mo). Laisser vide pour utiliser le logo SUCO",
    btn_start_trial: "Commencer l'essai gratuit de 7 jours",
    registering: "Inscription...",
    register_success: "Entreprise enregistrée ! Vous avez 7 jours d'essai gratuit",
    login_title: "Connexion",
    btn_login: "Se connecter",
    logging_in: "Connexion...",
    no_account: "Pas de compte ?",
    sign_up: "S'inscrire",
    welcome_back: "Bon retour !",
    dashboard_subtitle: "Panneau d'administration",
    tab_overview: "Aperçu",
    tab_complaints: "Plaintes et Suggestions",
    tab_qr: "Mon QR",
    btn_logout: "Déconnexion",
    free_trial: "Essai gratuit",
    stat_total: "Total",
    stat_pending: "En attente",
    stat_resolved: "Résolus",
    stat_complaints: "Plaintes",
    stat_suggestions: "Suggestions",
    no_messages: "Pas encore de messages",
    share_qr: "Partagez votre QR pour recevoir des commentaires",
    complaint: "Plainte",
    suggestion: "Suggestion",
    change_status: "Changer le statut",
    status_pending: "En attente",
    status_in_progress: "En cours",
    status_resolved: "Résolu",
    status_closed: "Fermé",
    qr_title: "Votre code QR personnalisé",
    qr_subtitle: "Partagez-le avec vos clients pour recevoir des commentaires",
    public_url: "URL publique :",
    download_qr: "Télécharger QR",
    download_pdf: "Télécharger PDF",
    download_docx: "Télécharger DOCX",
    wifi_qr_title: "QR Code WiFi",
    wifi_qr_subtitle: "Générez un QR code pour que vos clients se connectent à votre WiFi",
    wifi_network_name: "Nom du réseau",
    wifi_password: "Mot de passe",
    wifi_password_placeholder: "Laisser vide s'il n'y a pas de mot de passe",
    wifi_security: "Type de sécurité",
    wifi_no_password: "Sans mot de passe",
    wifi_generate_btn: "Générer QR WiFi",
    wifi_qr_generated: "QR WiFi généré avec succès",
    wifi_ssid_required: "Le nom du réseau est obligatoire",
    wifi_download_qr: "Télécharger QR WiFi",
    tab_branches: "Succursales",
    branches_title: "WiFi par Succursale",
    branches_subtitle: "Générez un QR WiFi indépendant pour chacune de vos succursales",
    branches_no_branches: "Aucune succursale enregistrée. Ajoutez-les depuis votre compte entreprise.",
    branch_label: "Succursale",
    branch_wifi_for: "WiFi de la succursale",
    regenerate_qr: "Régénérer QR",
    qr_regenerated: "QR et affiches régénérés avec succès",
    feedback_question: "Quelle est votre plainte ou suggestion ?",
    category: "Catégorie",
    describe_problem: "Décrivez le problème ou votre suggestion",
    tell_us: "Racontez-nous votre expérience...",
    name_optional: "Nom (optionnel)",
    email_optional: "Email (optionnel)",
    phone_optional: "Téléphone (optionnel)",
    btn_send: "Envoyer",
    btn_clear: "Effacer",
    sending: "Envoi...",
    thank_you: "Merci !",
    message_sent: "Votre message a été envoyé avec succès.",
    send_another: "Envoyer un autre",
    powered_by: "Powered by SUCO",
    choose_plan: "Choisissez votre plan",
    plan_subtitle: "Profitez de 7 jours gratuits, puis choisissez le plan idéal",
    monthly: "Plan Mensuel",
    yearly: "Plan Annuel",
    savings: "d'économie",
    btn_subscribe: "S'abonner",
    processing: "Traitement...",
    per_year: "/an",
    per_month: "/mois",
    loading_plans: "Chargement des plans...",
    verifying_payment: "Vérification du paiement...",
    wait_confirmation: "Veuillez patienter pendant que nous confirmons votre paiement",
    payment_success: "Paiement réussi !",
    subscription_active: "Votre abonnement est actif",
    trial_banner: "Essai gratuit : {days} jours restants",
    trial_banner_last_day: "Essai gratuit : dernier jour",
    trial_expired: "Votre essai gratuit a expiré",
    trial_expired_msg: "Abonnez-vous pour continuer à utiliser SUCO",
    cancel_subscription: "Annuler l'abonnement",
    cancel_confirm: "Êtes-vous sûr ? Vous perdrez l'accès à la fin de votre période de facturation",
    subscription_cancelled: "Abonnement annulé avec succès",
    go_dashboard: "Aller au Dashboard",
    payment_error: "Erreur de paiement",
    payment_confirm_error: "Nous n'avons pas pu confirmer votre paiement",
    try_again: "Réessayer",
    your_name: "Votre nom",
    email_placeholder: "email@exemple.com",
    phone_placeholder: "+33 6 00 00 00 00",
    error_payment: "Erreur lors du démarrage du paiement",
    business_not_found: "Entreprise non trouvée",
    back_home: "Retour à l'accueil",
    loading: "Chargement...",
    error_loading: "Erreur de chargement des données",
    invalid_credentials: "Identifiants invalides",
    error_registering: "Erreur d'inscription",
    error_sending: "Erreur d'envoi",
    status_updated: "Statut mis à jour",
    tab_profile: "Mon Profil",
    profile_title: "Modifier le Profil",
    profile_subtitle: "Mettez à jour les informations de votre entreprise",
    email_cc: "Email CC (notifications)",
    email_cc_hint: "Cet email recevra également les notifications de plaintes et suggestions",
    change_logo: "Changer le logo",
    save_changes: "Enregistrer",
    support: "Support",
    download_email_template: "Télécharger email commercial (Word)",
    saving: "Enregistrement...",
    profile_updated: "Profil mis à jour avec succès",
    error_updating: "Erreur lors de la mise à jour du profil",
    current_logo: "Logo actuel",
    no_logo: "Pas de logo personnalisé",
    tab_analytics: "Analytique",
    analytics_title: "Analyse des Tendances",
    analytics_subtitle: "Visualisez les performances de votre entreprise",
    period_7d: "7 jours",
    period_30d: "30 jours",
    period_90d: "90 jours",
    trend_chart_title: "Plaintes et Suggestions par jour",
    status_chart_title: "Répartition par Statut",
    total_in_period: "Total sur la période",
    no_data: "Aucune donnée pour la période sélectionnée",
    complaints_label: "Plaintes",
    suggestions_label: "Suggestions",
    remove: "Supprimer",
    or: "ou",
    back: "Retour",
    anonymous: "Anonyme",

    // Landing Page
    lp_nav_how: "Comment ca marche",
    lp_nav_pricing: "Tarifs",
    lp_nav_download: "Télécharger",
    lp_nav_login: "Se connecter",
    lp_nav_cta: "Essayer gratuitement",
    lp_hero_title: "Evitez les mauvais avis sur Google",
    lp_hero_highlight: "avant qu'ils arrivent",
    lp_hero_desc: "Capturez les plaintes de vos clients directement dans votre commerce avec un simple QR code. Ils se confient a vous, pas sur internet.",
    lp_hero_cta: "Commencer gratuitement",
    lp_hero_how: "Voir comment ca marche",
    lp_hero_badge: "Plainte recue en prive",
    lp_problem_label: "Le probleme",
    lp_problem_title: "Vos clients insatisfaits ne se plaignent pas a vous...",
    lp_problem_stat_text: "des clients insatisfaits ne se plaignent jamais directement. Ils ne reviennent tout simplement pas et laissent un mauvais avis sur Google.",
    lp_problem_card1_title: "Clients qui partent en silence",
    lp_problem_card1_desc: "Ils ne vous disent pas ce qui les a genes. Ils ne reviennent pas et vous ne savez jamais pourquoi.",
    lp_problem_card2_title: "Avis negatifs publics",
    lp_problem_card2_desc: "Au lieu de vous le dire, ils le publient sur Google pour que tout le monde voie.",
    lp_problem_card3_title: "Perte de reputation",
    lp_problem_card3_desc: "Chaque mauvais avis eloigne de nouveaux clients potentiels de votre commerce.",
    lp_solution_label: "La solution",
    lp_solution_title: "Voila comment SUCO fonctionne",
    lp_solution_subtitle: "En 3 etapes, transformez un client mecontent en client fidele",
    lp_step1_title: "Le client scanne le QR",
    lp_step1_desc: "Placez le QR sur les tables, le comptoir ou les recus. Aucune app a installer.",
    lp_step2_title: "Laisse son avis en prive",
    lp_step2_desc: "Se confie directement a vous en quelques secondes. Se sent ecoute et valorise.",
    lp_step3_title: "Vous recevez l'alerte instantanement",
    lp_step3_desc: "Vous recevez un email immediat. Vous pouvez agir vite et recuperer le client.",
    lp_benefits_label: "Avantages",
    lp_benefits_title: "Tout ce dont vous avez besoin pour proteger votre commerce",
    lp_benefit1_title: "Evitez les mauvais avis",
    lp_benefit1_desc: "Les plaintes arrivent chez vous avant d'arriver sur Google Maps ou les reseaux sociaux.",
    lp_benefit2_title: "Recuperez vos clients",
    lp_benefit2_desc: "Reagissez vite et transformez une mauvaise experience en fidelite.",
    lp_benefit3_title: "Ameliorez votre service",
    lp_benefit3_desc: "Recevez des retours reels et directs pour vous ameliorer continuellement.",
    lp_benefit4_title: "Simple, fonctionne en minutes",
    lp_benefit4_desc: "Pas d'installation. Inscrivez-vous, imprimez votre QR et c'est parti.",
    lp_benefit5_title: "9 langues incluses",
    lp_benefit5_desc: "Vos clients peuvent laisser leurs commentaires dans leur langue preferee.",
    lp_benefit6_title: "QR avec votre logo",
    lp_benefit6_desc: "Personnalisez le QR avec le logo de votre entreprise pour plus de confiance.",
    lp_new: "Nouveau",
    lp_wifi_title: "QR WiFi pour les clients",
    lp_wifi_desc: "Générez un QR code pour que vos clients se connectent facilement à votre WiFi. Optionnel et avec le logo de votre entreprise.",
    lp_pricing_label: "Tarifs",
    lp_pricing_title: "Simple et transparent",
    lp_pricing_subtitle: "Commencez avec 7 jours gratuits. Sans engagement, annulez quand vous voulez.",
    lp_pricing_business: "Pour votre commerce",
    lp_pricing_monthly: "Plan Mensuel",
    lp_pricing_yearly: "Plan Annuel",
    lp_pricing_save: "Economisez 29%",
    lp_pricing_f1: "QR illimites",
    lp_pricing_f2: "Alertes en temps reel",
    lp_pricing_f3: "Tableau de bord analytique",
    lp_pricing_f4: "9 langues",
    lp_pricing_f5: "Support par email",
    lp_pricing_yf1: "Tout du plan mensuel",
    lp_pricing_yf2: "Economisez $45.88 par an",
    lp_pricing_yf3: "Support prioritaire",
    lp_pricing_yf4: "QR avec logo personnalise",
    lp_pricing_yf5: "Affiches PDF et DOCX",
    lp_pricing_enterprise_label: "Pour les entreprises avec des succursales",
    lp_pricing_enterprise_badge: "Multi-succursale",
    lp_pricing_enterprise: "Plan Entreprise",
    lp_pricing_enterprise_extra: "+ 5.99$/mois par succursale supplementaire",
    lp_pricing_ef1: "1 succursale incluse",
    lp_pricing_ef2: "Dashboard centralise",
    lp_pricing_ef3: "Email independant par succursale",
    lp_pricing_ef4: "QR unique par succursale",
    lp_pricing_ef5: "Analyses comparatives",
    lp_pricing_ef6: "Support prioritaire",
    lp_pricing_example: "Exemple: 17 succursales = 125.83$/mois ou 1 243$/an",
    lp_pricing_contact: "Contacter les ventes",
    lp_pricing_trial: "7 jours d'essai gratuit inclus dans tous les plans",
    lp_trust_title: "Ideal pour les commerces qui tiennent a leur reputation",
    lp_trust_desc: "SUCO est concu pour tout commerce ou l'experience client compte.",
    lp_trust_tags: "Restaurants,Cafes,Salons de coiffure,Garages,Veterinaires,Cabinets medicaux,Salles de sport,Hotels",
    lp_download_title: "Telechargez SUCO sur votre appareil",
    lp_download_desc: "Installez SUCO comme application. Sans app store, sans attente.",
    lp_download_btn: "Installer SUCO",
    lp_download_desktop: "Sur ordinateur (Chrome)",
    lp_download_android: "Sur Android (Chrome)",
    lp_download_ios: "Sur iPhone / iPad (Safari)",
    lp_download_d1: "Ouvrez sucomx.com dans Google Chrome",
    lp_download_d2: "Cliquez sur l'icone d'installation dans la barre d'adresse",
    lp_download_d3: "Confirmez avec Installer",
    lp_download_a1: "Ouvrez sucomx.com dans Chrome",
    lp_download_a2: "Appuyez sur le menu (trois points) en haut a droite",
    lp_download_a3: "Selectionnez Installer l'application",
    lp_download_i1: "Ouvrez sucomx.com dans Safari",
    lp_download_i2: "Appuyez sur Partager",
    lp_download_i3: "Selectionnez Ajouter a l'ecran d'accueil",
    lp_cta_title: "Commencez aujourd'hui et arretez de perdre des clients sans savoir pourquoi",
    lp_cta_desc: "Inscrivez-vous en moins de 2 minutes. Sans carte de credit.",
    lp_cta_btn: "Commencer maintenant",
    lp_footer: "Systeme de feedback QR. Tous droits reserves."
  }
};

// Detect browser language and return supported language code
export const detectLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  const langCode = browserLang.split('-')[0].toLowerCase();
  
  // Return detected language if supported, otherwise default to Spanish
  return translations[langCode] ? langCode : 'es';
};

// Get translation for a key
export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations['es'][key] || key;
};

// Export all translations
export default translations;
